import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CalenderIcon from "../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import FullScreenIcon from "../../../svg/Ads_Dashboard_Developement2/FullScreenIcon/elements.svg";
import IIcon from "../../../svg/Ads_Dashboard_Developement2/IIcon/elements.svg";
import ExportIcon from "../../../svg/Ads_Dashboard_Developement2/ExportIcon/elements.svg";
import CurrentPeriodPositiveIcon from "../../../svg/Ads_Dashboard_Developement2/CurrentPeriodPositiveIcon/elements.svg";
import CurrentPeriodNegativeIcon from "../../../svg/Ads_Dashboard_Developement2/CurrentPeriodNegativeIcon/elements.svg";
import DragAndDropIcon from "../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import CompareTwoDateRangeComponent from "../../commonComponents/ComparisonDateRangeComponent/CompareTwoDateRangeComponent 1";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  startOfWeek,
  subMonths,
  subWeeks,
} from "date-fns";
import {
  Button,
  CircularProgress,
  DialogContent,
  Drawer,
  Option,
  Select,
  selectClasses,
  Switch,
  Tooltip,
} from "@mui/joy";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import { ColDef } from "ag-grid-community";
import appError from "../../../appError";
import { BASE_URL, BLACK, WHITE } from "../../../appConstants";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { downloadCSV, getFormattedValue, removeCommas } from "../../../appFunctions";
import ComparisonExportSelectionModal from "../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Export Functionality/ComparisonExportSelectionModal";
import OverviewComparisonCustomExportModal from "../../commonComponents/Ads_Dashboard_Cmps/Comparison Components/Export Functionality/OverviewComparisonCustomExportModal";
import View from "./Comparison_View_Cmps/ViewComponent1";
import ViewComponent2 from "./Comparison_View_Cmps/ViewComponent2";


type DateProps = {
  startDate: Date;
  endDate: Date;
};
type IpDate = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type Range = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type DataProps = {
  id: number;
  matrice_name: string;
  base_period: Number;
  comparison_period: Number;
  difference?: Number;
  differencePercentage?: Number;
  backend_matrice_name: string;
};
type Matrice = {
  id: number;
  matrice_name: string;
  backend_matrice_name: string;
  toggle: boolean;
  position: number;
};
type RangeProps = {
  min_date: Date;
  max_date: Date;
};
type Parameter = {
  id: number;
  parameter_name: string;
  backend_parameter_name: string;
  toggle: boolean;
  position: number;
};

const OverviewComparisonPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [dateToggle, setDateToggle] = useState<boolean>(false);
  const [range, setRange] = useState<RangeProps>({} as RangeProps);

  const getWeekRange = (date: Date) => {
    const todayDate = date.getDate();

    // Define fixed week ranges
    const weeks: [number, number][] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];

    // Find the index of the current week
    const currentWeekIndex = weeks.findIndex(
      ([start, end]) => todayDate >= start && todayDate <= end
    );
    if (currentWeekIndex === -1) return null; // Fallback in case no match is found

    // Get the current and previous week's range
    const [currentStart, currentEnd] = weeks[currentWeekIndex];

    let prevStart, prevEnd, month, year;
    if (currentStart === 1 && currentEnd === 7) {
      const lastMonthDate = subMonths(date, 1);
      const prevMonthLastDate = endOfMonth(lastMonthDate)?.getDate();

      const prevWeek = weeks.find(
        ([start, end]) => prevMonthLastDate >= start && prevMonthLastDate <= end
      );
      prevStart = prevWeek?.[0];
      prevEnd = endOfMonth(lastMonthDate)?.getDate();
      month = lastMonthDate?.getMonth();
      year = lastMonthDate?.getFullYear();
    } else {
      const lastweek = weeks[currentWeekIndex - 1] || [1, 7]; // Default to first week if no previous
      prevStart = lastweek?.[0];
      prevEnd = lastweek?.[1];
      month = date?.getMonth();
      year = date?.getFullYear();
    }

    return {
      previousWeekStart: new Date(year, month, prevStart),
      previousWeekEnd: new Date(year, month, prevEnd),
      currentWeekStart: new Date(
        date?.getFullYear(),
        date?.getMonth(),
        currentStart
      ),
    };
  };

  const today = new Date();
  const [InputRange, setInputRange] = useState<Range>({
    // ------- Input
    rangeOne: {
      // Current Date
      startDate: today,
      endDate: today,
    },
    rangeTwo: {
      // Comparison Date
      startDate: today,
      endDate: today,
    },
  });
  const [loading, setLoading] = useState<boolean>(false); // Loader for Table
  const { brand_id } = useParams();
  const { platform_id } = useSelector((state: any) => state.appData);

  const [matricesData, setMatricesData] = useState<Matrice[]>([]);
  // Drawer
  const [matricesDataDrawer, setMatricesDataDrawer] = useState<Matrice[]>([]);
  const [resetToggle, setResetToggle] = useState<boolean>(false);

  const IconTooltip: React.FC<{ name: string }> = ({ name }) => {
    return (
      <div
        className="inline-flex items-center gap-2 rounded-[8px]"
        style={{ backgroundColor: "#3C3C3F" }}
      >
        <div
          style={{
            color: "var(--Text-Primary-White, #97979A)",
            fontFamily: "Inter",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "10px",
            letterSpacing: "1.6px",
            textTransform: "uppercase",
          }}
        >
          Range
        </div>
        <div
          style={{
            color: "var(--Text-Primary-White, #FFF)",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "18px",
          }}
        >
          {name}
        </div>
      </div>
    );
  };

  const MatriceNameHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[120px] items-center justify-start self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };
  const CurrentHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[163px] items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
        <Tooltip
          title={
            <IconTooltip
              name={`${String(
                InputRange?.rangeOne?.startDate.getDate()
              ).padStart(2, "0")}/${String(
                InputRange?.rangeOne?.startDate.getMonth() + 1
              ).padStart(
                2,
                "0"
              )}/${InputRange?.rangeOne?.startDate.getFullYear()} - ${String(
                InputRange?.rangeOne?.endDate.getDate()
              ).padStart(2, "0")}/${String(
                InputRange?.rangeOne?.endDate.getMonth() + 1
              ).padStart(
                2,
                "0"
              )}/${InputRange?.rangeOne?.endDate.getFullYear()} `}
            />
          }
          placement="right"
          arrow
          sx={{
            bgcolor: "#3C3C3F",
            padding: "16px",
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "500",
            fontStyle: "normal",
            lineHeight: "18px",
            color: WHITE.W_100,
          }}
        >
          <img src={IIcon} alt="Icon" style={{ cursor: "pointer" }} />
        </Tooltip>
      </div>
    );
  };
  const ComparisonHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[163px] items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
        <Tooltip
          title={
            <IconTooltip
              name={`${String(
                InputRange?.rangeTwo?.startDate.getDate()
              ).padStart(2, "0")}/${String(
                InputRange?.rangeTwo?.startDate.getMonth() + 1
              ).padStart(
                2,
                "0"
              )}/${InputRange?.rangeTwo?.startDate.getFullYear()} - ${String(
                InputRange?.rangeTwo?.endDate.getDate()
              ).padStart(2, "0")}/${String(
                InputRange?.rangeTwo?.endDate.getMonth() + 1
              ).padStart(
                2,
                "0"
              )}/${InputRange?.rangeTwo?.endDate.getFullYear()} `}
            />
          }
          placement="right"
          arrow
          sx={{
            bgcolor: "#3C3C3F",
            padding: "16px",
            display: "inline-flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "500",
            fontStyle: "normal",
            lineHeight: "18px",
            color: WHITE.W_100,
          }}
        >
          <img src={IIcon} alt="Icon" style={{ cursor: "pointer" }} />
        </Tooltip>
      </div>
    );
  };
  const DiffHeaderCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[163px] items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };
  const DiffPercentageHeaderCmp = (params: any) => {
    return (
      <div
        className="w-[130px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };

  const [rsmatricearr, setRsMatricearr] = useState(["spend", "sales", "gross_sales_seller", "gross_sales_vendor", "organic_sales"]);

  const MatricesNameRenderer = (params: any) => {
    return (
      <div className="flex w-[120px] px-6 py-2 items-center justify-start self-stretch gap-2">
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "18px",
          }}
        >
          {transposeFormat === "VERTICAL" ? params?.data?.matrice_name : params?.value}
        </div>
      </div>
    );
  };
  const CurrentRenderer = (params: any) => {
    const {
      backend_matrice_name,
      base_period = 0,
      comparison_period = 0,
    } = params?.data;
    const baseValue = Number(base_period);
  const comparisonValue = Number(comparison_period);

  const negativeGrowthMetrics = ["spend", "acos", "tacos", "cpc", "cac"]; // Lower is better

  // Determine if the change is positive based on the metric type
  const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
    ? comparisonValue > baseValue // if base is less = good
    : baseValue > comparisonValue; // if base is more = good
  const isDifferent = baseValue !== comparisonValue;

    return (
      <div className="flex w-[163px] px-6 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {rsmatricearr?.includes(backend_matrice_name) ? `₹ ${getFormattedValue(params?.data?.base_period)}` : getFormattedValue(params?.data?.base_period)}
        </div>
        {isDifferent && (<div
          className="flex p-1 w-[22px] items-center gap-1 rounded-[4px]"
          style={{
            backgroundColor: isPositiveTrend ? "#DEF7E4" : "#FFECEB",
          }}
        >
          <img
            src={
              isPositiveTrend
                ? CurrentPeriodPositiveIcon
                : CurrentPeriodNegativeIcon
            }
            alt="Icon"
            style={{ cursor: "pointer" }}
          />
        </div>)}
      </div>
    );
  };
  const ComparisonPeriodRenderer = (params: any) => {
    return (
      <div className="flex px-6 py-2 w-[163px] items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
            color: "#1C1C1E",
          }}
        >
          {rsmatricearr?.includes(params?.data?.backend_matrice_name) ? `₹ ${getFormattedValue(params?.data?.comparison_period)}` : getFormattedValue(params?.data?.comparison_period)}
        </div>
      </div>
    );
  };
  const DiffRenderer = (params: any) => {
    const { backend_matrice_name, base_period = "0", comparison_period = "0" } = params?.data;
    const difference = Number((base_period)) - Number((comparison_period));
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    const absoluteDifference = decimaldigitsMetrics.includes(backend_matrice_name) ? (Number(difference?.toFixed(2))) : (difference);

    // Matrices where lower values are better
    const negativeGrowthMetrics = ["spend","acos","tacos", "cpc", "cac" ];

    const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
      ? Number(comparison_period) > Number(base_period) // These should be lower
      : Number(comparison_period) < Number(base_period); // Others should be higher

    const isSame = Number(comparison_period) === Number(base_period);

    const color = isSame
      ? "#1C1C1E" // neutral
      : isPositiveTrend
      ? "#186846" // green
      : "#D10C00"; // red
    return (
      <div className="flex w-[163px] px-6 py-2 items-center justify-end self-stretch gap-2">
        <div
          style={{
            color: color,
            textAlign: "end",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {rsmatricearr?.includes(params?.data?.backend_matrice_name) ? `₹ ${getFormattedValue(absoluteDifference)}` : getFormattedValue(absoluteDifference)}
          {/* {getFormattedValue(absoluteDifference)} */}
        </div>
      </div>
    );
  };
  const DiffInPercentageRenderer = (params: any) => {
    const basePeriod = Number(params?.data?.base_period ?? "0"); 
    const comparisonPeriod = Number(params?.data?.comparison_period ?? "0"); 
    const backend_matrice_name = params?.data?.backend_matrice_name;
    // Ensure the values are treated as numbers, and the difference calculation is correct.
    const difference = basePeriod - comparisonPeriod;
  
    let diffPercentage = 0;

    if (comparisonPeriod !== 0) {
      diffPercentage = (difference / comparisonPeriod) * 100;
    }
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    const formattedPercentage = decimaldigitsMetrics.includes(backend_matrice_name)
    ? Number(diffPercentage.toFixed(2))
    : Math.round(diffPercentage);

    const isSame = basePeriod === comparisonPeriod;

    const negativeGrowthMetrics = ["spend", "acos","tacos", "cpc", "cac" ];
    const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
      ? comparisonPeriod > basePeriod  // lower is better, so if base is lower = green
      : basePeriod > comparisonPeriod; // higher is better

    const color = isSame
      ? "#1C1C1E"
      : isPositiveTrend
      ? "#186846"
      : "#D10C00";

    return (
      <div className="flex w-[130px] px-6 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            color: color,
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {`${isNaN(formattedPercentage) ? "0" : getFormattedValue(formattedPercentage)} %`}

          {/* {`${Math.abs(Number(diffPercentage?.toFixed(2))) === "NaN" ? "0" : "0"}  %`} */}
        </div>
      </div>
    );
  };

  const HorizontalCellRenderer = (params: any) => {
    const current_obj = filterdata?.find((item : any) => item?.range_name === "base_period");
    const comparison_obj = filterdata?.find((item : any) => item?.range_name === "comparison_period");
    const field = params?.colDef?.field as keyof DataProps;
    const basePeriod = Number(current_obj?.[field] ?? "0"); 
    const comparisonPeriod = Number(comparison_obj?.[field] ?? "0"); 
    const difference = basePeriod - comparisonPeriod;
    let diffPercentage = 0;

    if (comparisonPeriod !== 0) {
      diffPercentage = (difference / comparisonPeriod) * 100;
    }
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    const formattedPercentage = decimaldigitsMetrics.includes(field)
    ? Number(diffPercentage.toFixed(2))
    : Math.round(diffPercentage);

    const isSame = basePeriod === comparisonPeriod;

    const negativeGrowthMetrics = ["spend", "acos","tacos", "cpc", "cac" ];
    const isPositiveTrend = negativeGrowthMetrics.includes(field)
      ? comparisonPeriod > basePeriod  // lower is better, so if base is lower = green
      : basePeriod > comparisonPeriod;
    
    const color = isSame
      ? "#1C1C1E"
      : isPositiveTrend
      ? "#186846"
      : "#D10C00"; 
    return (
      <div className="flex w-[150px] px-6 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            color: params?.data?.range_name === "difference" || params?.data?.range_name === "differencePercentage" ? color : "#1C1C1E",
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {rsmatricearr?.includes(params?.colDef?.field) ? 
            (params?.data?.range_name === "differencePercentage" ? `${getFormattedValue(params?.value)} %` : `₹ ${getFormattedValue(params?.value)}`
            ) : (
              params?.data?.range_name === "differencePercentage" ? `${getFormattedValue(params?.value)} %` : getFormattedValue(params?.value)
            )
          }
        </div>
        {params?.data?.range_name === "base_period" && !isSame && (<div
          className="flex p-1 w-[22px] items-center gap-1 rounded-[4px]"
          style={{
            backgroundColor: isPositiveTrend ? "#DEF7E4" : "#FFECEB",
          }}
        >
          <img
            src={
              isPositiveTrend
                ? CurrentPeriodPositiveIcon
                : CurrentPeriodNegativeIcon
            }
            alt="Icon"
            style={{ cursor: "pointer" }}
          />
        </div>)}
      </div>
    )
  }
  const PeriodcolHeaderHorCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[170px] items-center justify-start self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };
  const MatriceNameHeaderHorCmp = (params: any) => {
    return (
      <div
        className="flex px-6 py-2 w-[170px] items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: "#F3F3F7",
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "end",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.displayName}
        </div>
      </div>
    );
  };
  const MatricesNameHorRenderer = (params: any) => {
    return (
      <div className="flex w-[120px] px-6 py-2 items-center justify-start self-stretch gap-2">
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "18px",
          }}
        >
          {transposeFormat === "VERTICAL" ? params?.data?.matrice_name : params?.value}
        </div>
      </div>
    );
  };

  
  const verticalcolDefs: ColDef<DataProps>[] = [
    {
      field: "matrice_name",
      headerName: "Metrics",
      sortable: false,
      cellRenderer: MatricesNameRenderer,
      headerComponent: MatriceNameHeaderCmp,
      // width: 163,
    },
    {
      field: "base_period",
      headerName: "Current Period",
      sortable: false,
      cellRenderer: CurrentRenderer,
      headerComponent: CurrentHeaderCmp,
      // width: 163,
    },
    {
      field: "comparison_period",
      headerName: "Comparison Period",
      sortable: false,
      cellRenderer: ComparisonPeriodRenderer,
      headerComponent: ComparisonHeaderCmp,
      // width: 163,
    },
    {
      field: "difference",
      headerName: "Difference",
      sortable: false,
      cellRenderer: DiffRenderer,
      headerComponent: DiffHeaderCmp,
      // width: 163,
    },
    {
      field: "differencePercentage",
      headerName: "Difference %",
      sortable: false,
      cellRenderer: DiffInPercentageRenderer,
      headerComponent: DiffPercentageHeaderCmp,
      // width: 163,
    },
  ];

  const [horizontalcolData, setHorizontalcolData] = useState<ColDef<any>[]>([]);
  const [allhorizontalcolData, setAllHorizontalcolData] = useState<ColDef<any>[]>([]);
  const [fetchData, setFetchData] = useState<DataProps[]>([]);
  const [filterdata, setfilterData] = useState<DataProps[]>([]);
  const [datafetchingState, setDataFetchingState] = useState<string>("");
  const [rowsToggle, setRowsToggle] = useState<boolean>(false);
  // const defaultColDef = {
  //   flex: 1,
  // };

  const apply = (date: IpDate) => {
    setInputRange((prev) => ({
      ...prev,
      rangeOne: date?.rangeOne,
    }));
    setInputRange((prev) => ({
      ...prev,
      rangeTwo: date?.rangeTwo,
    }));
    let InitialRange = {
      rangeOne: date?.rangeOne,
      rangeTwo: date?.rangeTwo,
    };
    FetchComparisonDataHandler(InitialRange, transposeFormat);
    fetchSection2Data(view, performer, product_detail, InitialRange, metricsData2, parametersData2);
  };

  // PUT API for Column
  const updateColumns = async (
    column_name: string,
    ipNewMatricesArr: Matrice[]
  ) => {
    try {
      const token = localStorage.getItem("token");
      interface TempObj {
        dashboard: string;
        column_type: string;
        column_array?: any[]; // Optional property, replace `any[]` with a specific type if known
      }
      let temp_obj: TempObj = {
        dashboard: "ADS_OVERVIEW_ANALYSIS",
        column_type: column_name,
      };
      if (column_name === "METRICE") {
        temp_obj.column_array = ipNewMatricesArr;
      }
      const res = await axios.put(
        `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      appError(error);
    }
  };

  const handleSwitchChange = (matrice_id: Number, matricesDataDrawer: Matrice[]) => {
    const Exist = matricesDataDrawer.find(
      (d: Matrice) => d?.id === matrice_id
    )?.toggle;
    let newMatricesArr = [] as Matrice[];
    if (Exist) {
      if (matricesDataDrawer.filter((item) => item.toggle).length === 1) {
        toast.error("Minimum 1 Matrice to be present");
        return;
      } else if (matricesDataDrawer.filter((item) => item.toggle).length > 1) {
        newMatricesArr = matricesDataDrawer.map((d) =>
          d.id === matrice_id ? { ...d, toggle: false } : d
        );
      }
    } else {
      newMatricesArr = matricesDataDrawer.map((d) =>
        d.id === matrice_id ? { ...d, toggle: true } : d
      );
    }

    return newMatricesArr;
    // setMatricesDataDrawer(newMatricesArr);
    // updateColumns("METRICE", newMatricesArr);
  };
  
  const [draggedItem, setDraggedItem] = useState<Matrice | null>(null);
  const handleDragStart = (item: Matrice) => {
    setDraggedItem(item);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (targetItem: Matrice, ag_matricesDataDrawer: Matrice[]) => {
    if (!draggedItem || draggedItem.id === targetItem.id) return;
  
    const draggedIndex = ag_matricesDataDrawer.findIndex(
      (item) => item?.id === draggedItem.id
    );
    const targetIndex = ag_matricesDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...ag_matricesDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));
  
    return reorderedMatricesData;
    // setMatricesDataDrawer(reorderedMatricesData);
    // updateColumns("METRICE", reorderedMatricesData); // Uncomment if needed
  };
  
  // const [rawData, setRawData] = useState<any[]>([]);
  const [transposeFormat, setTransposeFormat] = useState<string>("VERTICAL");
  const [agGridTableWidth, setAgGridTableWidth] = useState<number>(0);

  const FetchComparisonDataHandler = async (UserInputRange: Range, ip_transposeFormat: string) => {
    let filter = {
      current_data_range: {
        start_date: `${UserInputRange?.rangeOne?.startDate.getFullYear()}-${String(
          UserInputRange?.rangeOne?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeOne?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${UserInputRange?.rangeOne?.endDate.getFullYear()}-${String(
          UserInputRange?.rangeOne?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeOne?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
      previous_data_range: {
        start_date: `${UserInputRange?.rangeTwo?.startDate.getFullYear()}-${String(
          UserInputRange?.rangeTwo?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeTwo?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${UserInputRange?.rangeTwo?.endDate.getFullYear()}-${String(
          UserInputRange?.rangeTwo?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeTwo?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
    };
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getComparasionOfTwoRange?brand_id=${brand_id}`;
      const result = await axios.post(api, filter, { headers });
      const { range } = result?.data?.data;
      if (!range || range.length !== 2) {
        appError("Invalid range data:", range);
      }
      const currentPeriod = range?.find(
        (item: any) => item.range_name === "current"
      );
      const previousPeriod = range?.find(
        (item: any) => item.range_name === "previous"
      );

      if (!currentPeriod || !previousPeriod) {
        appError("Missing 'current' or 'previous' range data.");
        return; // Trow error
      }

      const metrics = [
        { id: 1, matrice_name: "Impressions", backend_matrice_name: "impressions" },
        { id: 2, matrice_name: "Clicks", backend_matrice_name: "clicks" },
        { id: 3, matrice_name: "Spend", backend_matrice_name: "spend" },
        { id: 4, matrice_name: "Ad Sales", backend_matrice_name: "sales" },
        { id: 5, matrice_name: "Ad Sales %", backend_matrice_name: "ad_sales_perc" },
        {
          id: 6,
          matrice_name: "Gross Sales (Seller)",
          backend_matrice_name: "gross_sales_seller",
        },
        {
          id: 7,
          matrice_name: "Gross Sales (Vendor)",
          backend_matrice_name: "gross_sales_vendor",
        },
        {
          id: 8,
          matrice_name: "Organic Sales",
          backend_matrice_name: "organic_sales",
        },
        {
          id: 9,
          matrice_name: "Organic Sales %",
          backend_matrice_name: "organic_sales_perc",
        },
        { id: 10, matrice_name: "Ad Orders", backend_matrice_name: "orders" },
        { id: 11, matrice_name: "Ad Units", backend_matrice_name: "units" },
        {
          id: 12,
          matrice_name: "Gross Units (Seller)",
          backend_matrice_name: "gross_units_seller",
        },
        {
          id: 13,
          matrice_name: "Gross Units (Vendor)",
          backend_matrice_name: "gross_units_vendor",
        },
        { id: 14, matrice_name: "Organic Units", backend_matrice_name: "organic_units" },
        { id: 15, matrice_name: "ACOS", backend_matrice_name: "acos" },
        { id: 16, matrice_name: "TACOS", backend_matrice_name: "tacos" },
        { id: 17, matrice_name: "ROAS", backend_matrice_name: "roas" },
        { id: 18, matrice_name: "TROAS", backend_matrice_name: "troas" },
        { id: 19, matrice_name: "CTR", backend_matrice_name: "ctr" },
        { id: 20, matrice_name: "CVR", backend_matrice_name: "cvr" },
        { id: 21, matrice_name: "CPC", backend_matrice_name: "cpc" },
        { id: 22, matrice_name: "AOV", backend_matrice_name: "aov" },
        { id: 23, matrice_name: "CAC", backend_matrice_name: "cac" },
        {
          id: 24,
          matrice_name: "Glance View",
          backend_matrice_name: "gross_glanceviews",
        },
      ];

      if(ip_transposeFormat === "VERTICAL"){
        const formattedArray = metrics.map(
          ({ id, matrice_name, backend_matrice_name }) => ({
            id,
            matrice_name,
            base_period: currentPeriod[backend_matrice_name], 
            // Number(
            //   (currentPeriod[backend_matrice_name] ?? 0).toFixed(4)
            // ),
            comparison_period: previousPeriod[backend_matrice_name],
            // Number(
            //   (previousPeriod[backend_matrice_name] ?? 0).toFixed(4)
            // ),
            backend_matrice_name: backend_matrice_name,
          })
        );
        if (range?.length === 0) {
          setDataFetchingState("EMPTY");
        } else if (range?.length > 0) {
          // setRawData(formattedArrayForCsv);
          setFetchData(formattedArray);
          setDataFetchingState("SUCCESS");
        }

        setAgGridTableWidth(1000)
      }
      else{
        const decimaldigitsMetrics = [
          "acos", "tacos", "roas", "troas", "ctr", "cvr",
          "cpc", "aov", "cac", "ad_sales_perc", "organic_sales_perc"
        ];
      
        const currentRow: any = {
          range_frontend_name: "Current Period",
          range_name: "base_period"
        };
        const previousRow: any = {
          range_frontend_name: "Comparison Period",
          range_name: "comparison_period"
        };
        const differenceRow: any = {
          range_frontend_name: "Difference",
          range_name: "difference"
        };
        const diffPercentageRow: any = {
          range_frontend_name: "Difference %",
          range_name: "differencePercentage"
        };
      
        metrics.forEach(({ backend_matrice_name }) => {
          const currentValue = Number(currentPeriod[backend_matrice_name]);
          const previousValue = Number(previousPeriod[backend_matrice_name]);
      
          const isDecimal = decimaldigitsMetrics.includes(backend_matrice_name);
      
          currentRow[backend_matrice_name] = Number(isDecimal
            ? currentValue.toFixed(2)
            : currentValue.toFixed(0));
      
          previousRow[backend_matrice_name] = Number(isDecimal
            ? previousValue.toFixed(2)
            : previousValue.toFixed(0));

          const diff = currentValue - previousValue;
          differenceRow[backend_matrice_name] = Number(isDecimal
              ? diff.toFixed(2)
              : diff.toFixed(0));
          
          const percentageDiff = previousValue
              ? ((diff / previousValue) * 100)
              : 0;
          
          diffPercentageRow[backend_matrice_name] = isDecimal
              ? percentageDiff.toFixed(2)
              : percentageDiff.toFixed(0) ;
        });
      
        const formattedHorizontal = [currentRow, previousRow, differenceRow, diffPercentageRow];
        
        let horizontalcol: ColDef<any>[] = metrics.map(item => ({
          field: item?.backend_matrice_name,
          headerName: item?.matrice_name,
          sortable: false,
          cellRenderer: HorizontalCellRenderer,
          headerComponent: MatriceNameHeaderHorCmp,
          width: 150
        }));

        const metricKeys: string[] = [
          "current_period",
          "comparison_period",
          "difference",
          "difference_Percentage",
        ];
        
        const formattedArrayForCsvHor: any[] = metrics.map(
          ({ id, matrice_name, backend_matrice_name }) => {
            const base = Number(currentPeriod[backend_matrice_name] ?? 0);
            const comp = Number(previousPeriod[backend_matrice_name] ?? 0);
            const diff = base - comp;
            const isDecimal = decimaldigitsMetrics.includes(backend_matrice_name);
        
            return {
              id,
              matrice_name,
              backend_matrice_name,
              current_period: isDecimal ? base.toFixed(2) : base.toFixed(0),
              comparison_period: isDecimal ? comp.toFixed(2) : comp.toFixed(0),
              difference: isDecimal ? diff.toFixed(2) : diff.toFixed(0),
              difference_Percentage: comp
                ? `${(isDecimal ? ((diff / comp) * 100).toFixed(2) : ((diff / comp) * 100).toFixed(0))}%`
                : "0%",
            };
          }
        );
        
        // // Transpose logic
        const transposed = [
          // {
          //   label: "matrice_name",
          //   ...Object.fromEntries(formattedArrayForCsvHor.map(m => [m.backend_matrice_name, m.matrice_name]))
          // },
          ...metricKeys.map((key: string) => ({
            Period: key,
            ...Object.fromEntries(formattedArrayForCsvHor.map(m => [m.backend_matrice_name, m[key]]))
          }))
        ];

        if (range.length === 0) {
          setDataFetchingState("EMPTY");
        } else {
          let new_columns_defs: any[] = [{
            field: "range_frontend_name",
            headerName: "Period",
            sortable: false,
            pinned: 'left',
            cellRenderer: MatricesNameHorRenderer,
            headerComponent: PeriodcolHeaderHorCmp,
            width: 170,
          }, ...horizontalcol];

          // setRawData(transposed);
          setAllHorizontalcolData(new_columns_defs);
          setHorizontalcolData(new_columns_defs);

          setAgGridTableWidth(150*24 + 170);
          setFetchData(formattedHorizontal); 
          setfilterData(formattedHorizontal);
          setDataFetchingState("SUCCESS");
        }
      }
       
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  // const getBrandDetails = () => {
  //   const storedBrandRange = localStorage.getItem("BrandRange");
  //   if (storedBrandRange) {
  //     try {
  //       const parsedRange = JSON.parse(storedBrandRange);
  //       setRange({
  //         min_date: new Date(parsedRange?.min_date.split("T")[0]),
  //         max_date: new Date(parsedRange?.max_date.split("T")[0]),
  //       });
  //       let weekRange = getWeekRange(new Date());
  //       if (
  //         weekRange &&
  //         weekRange?.currentWeekStart >
  //           new Date(parsedRange?.max_date.split("T")[0])
  //       ) {
  //         weekRange = getWeekRange(
  //           new Date(parsedRange?.max_date.split("T")[0])
  //         );
  //       }
  //       let InitialRange = {
  //         rangeOne: {
  //           startDate: weekRange?.currentWeekStart || today,
  //           endDate: new Date(parsedRange?.max_date.split("T")[0]),
  //         },
  //         rangeTwo: {
  //           startDate: weekRange?.previousWeekStart || today,
  //           endDate: weekRange?.previousWeekEnd || today,
  //         },
  //       };
  //       setInputRange(InitialRange);
  //       FetchComparisonDataHandler(InitialRange);
  //     } catch (error) {
  //       appError("Error parsing BrandRange from localStorage:", error);
  //     }
  //   }
  // };

  const getBrandDetails = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getBrandRange?brand_id=${brand_id}`;
      const result = await axios.get(api, { headers });
      const { range } = result?.data?.data;
      if (range) {
        let new_range = {
          min_date: new Date(range[0]._col0.split("T")[0]),
          max_date: new Date(range[0]._col1.split("T")[0]),
        };
        setRange(new_range);
        let weekRange = getWeekRange(new Date());
        if (
          weekRange &&
          weekRange?.currentWeekStart >
            new Date(new_range?.max_date)
        ) {
          weekRange = getWeekRange(
            new Date(new_range?.max_date)
          );
        }
        let InitialRange = {
          rangeOne: {
            startDate: weekRange?.currentWeekStart || today,
            endDate: new Date(new_range?.max_date),
          },
          rangeTwo: {
            startDate: weekRange?.previousWeekStart || today,
            endDate: weekRange?.previousWeekEnd || today,
          },
        };
        setInputRange(InitialRange);
        FetchComparisonDataHandler(InitialRange, transposeFormat);
        const savedState = localStorage.getItem('overview_comparison_section2TableData');

        if (savedState) {
          const parsedState = JSON.parse(savedState);
          setView(parsedState?.ag_view);
          setPerformer(parsedState?.ag_performer);
          setProduct_detail(parsedState?.ag_productDetail);
          setMetricsData2(parsedState?.ag_metrics);
          setMatricesDataDrawer2(parsedState?.ag_metrics);
          setParametersData2(parsedState?.ag_parameters);
          setParametersDataDrawer2(parsedState?.ag_parameters);
          fetchSection2Data(parsedState?.ag_view, parsedState?.ag_performer, parsedState?.ag_productDetail, InitialRange, parsedState?.ag_metrics, parsedState?.ag_parameters);
        }
        else {
          fetchSection2Data(view, performer, product_detail, InitialRange, metricsData2, parametersData2);
        }
        setLoading(false);
      }
    } catch (error) {
      appError(error);
    }
  };

  // GET API For Column
  const fetchColumnData = async (column_name: string) => {
    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}settings/columnSettings?brand_id=${brand_id}&platform_id=${platform_id}&dashboard=ADS_OVERVIEW_ANALYSIS&column_type=${column_name}`;
      const result = await axios.get(api, { headers });
      const { column_array } = result.data.data;
      if (column_name === "METRICE") {
        if (column_array.length !== 0) {
          setMatricesData(column_array);
          setMatricesDataDrawer(column_array);
          let positionchangedfilter =  column_array?.filter((item: DataProps, index: number) => item.id !== (index + 1));
          if(positionchangedfilter?.length > 0){
            setResetToggle(true);
          }
        } else {
          let new_metrics_arr = [
            {
              id: 1,
              matrice_name: "Impressions",
              backend_matrice_name: "impressions",
              toggle: true,
              position: 0,
            },
            {
              id: 2,
              matrice_name: "Clicks",
              backend_matrice_name: "clicks",
              toggle: true,
              position: 1,
            },
            {
              id: 3,
              matrice_name: "Spend",
              backend_matrice_name: "cost",
              toggle: true,
              position: 2,
            },
            {
              id: 4,
              matrice_name: "Ad Sales",
              backend_matrice_name: "sales",
              toggle: true,
              position: 3,
            },
            {
              id: 5,
              matrice_name: "Ad Sales %",
              backend_matrice_name: "ad_sales_perc",
              toggle: true,
              position: 4,
            },
            {
              id: 6,
              matrice_name: "Gross Sales (Seller)",
              backend_matrice_name: "gross_sales_seller",
              toggle: true,
              position: 5,
            },
            {
              id: 7,
              matrice_name: "Gross Sales (Vendor)",
              backend_matrice_name: "gross_sales_vendor",
              toggle: true,
              position: 6,
            },
            {
              id: 8,
              matrice_name: "Organic Sales",
              backend_matrice_name: "organic_sales",
              toggle: true,
              position: 7,
            },
            {
              id: 9,
              matrice_name: "Organic Sales %",
              backend_matrice_name: "organic_sales_perc",
              toggle: true,
              position: 8,
            },
            {
              id: 10,
              matrice_name: "Ad Orders",
              backend_matrice_name: "orders",
              toggle: true,
              position: 9,
            },
            {
              id: 11,
              matrice_name: "Ad Units",
              backend_matrice_name: "units",
              toggle: true,
              position: 10,
            },
            {
              id: 12,
              matrice_name: "Gross Units (Seller)",
              backend_matrice_name: "gross_units_seller",
              toggle: true,
              position: 11,
            },
            {
              id: 13,
              matrice_name: "Gross Units (Vendor)",
              backend_matrice_name: "gross_units_vendor",
              toggle: true,
              position: 12,
            },
            {
              id: 14,
              matrice_name: "Organic Units",
              backend_matrice_name: "organic_units",
              toggle: true,
              position: 13,
            },
            {
              id: 15,
              matrice_name: "ACOS",
              backend_matrice_name: "acos",
              toggle: true,
              position: 14,
            },
            {
              id: 16,
              matrice_name: "TACOS",
              backend_matrice_name: "tacos",
              toggle: true,
              position: 15,
            },
            {
              id: 17,
              matrice_name: "ROAS",
              backend_matrice_name: "roas",
              toggle: true,
              position: 16,
            },
            {
              id: 18,
              matrice_name: "TROAS",
              backend_matrice_name: "troas",
              toggle: true,
              position: 17,
            },
            {
              id: 19,
              matrice_name: "CTR",
              backend_matrice_name: "ctr",
              toggle: true,
              position: 18,
            },
            {
              id: 20,
              matrice_name: "CVR",
              backend_matrice_name: "cvr",
              toggle: true,
              position: 19,
            },
            {
              id: 21,
              matrice_name: "CPC",
              backend_matrice_name: "cpc",
              toggle: true,
              position: 20,
            },
            {
              id: 22,
              matrice_name: "AOV",
              backend_matrice_name: "aov",
              toggle: true,
              position: 21,
            },
            {
              id: 23,
              matrice_name: "CAC",
              backend_matrice_name: "cac",
              toggle: true,
              position: 22,
            },
            {
              id: 24,
              matrice_name: "Glance View",
              backend_matrice_name: "gross_glanceviews",
              toggle: true,
              position: 23,
            },
          ];          
          setMatricesData(new_metrics_arr);
          setMatricesDataDrawer(new_metrics_arr);
        }
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  let exportRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let exportButtonRef = useRef<HTMLButtonElement | null>(null); // Menu button reference

  let dateRangeCmpRef: MutableRefObject<HTMLDivElement | null> = useRef(null);
  let dateRangeCmpButtonRef = useRef<HTMLImageElement | null>(null); // Menu button reference

  const exporthandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      exportRef.current &&
      !exportRef.current.contains(event.target as Node) &&
      exportButtonRef.current &&
      !exportButtonRef.current.contains(event.target as Node)
    ) {
      setExportToggle(false); // Close the dropdown if clicked outside
    }
  };

  const dateRangehandleClickOutside = (event: MouseEvent) => {
    // Check if the click is outside the dropdown (menuRef)
    if (
      dateRangeCmpRef.current &&
      !dateRangeCmpRef.current.contains(event.target as Node) &&
      dateRangeCmpButtonRef.current &&
      !dateRangeCmpButtonRef.current.contains(event.target as Node)
    ) {
      setDateToggle(false); // Close the dropdown if clicked outside
    }
  };

  // Add event listener to detect clicks outside
  useEffect(() => {
    document.addEventListener("click", exporthandleClickOutside);
    document.addEventListener("click", dateRangehandleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", exporthandleClickOutside);
      document.removeEventListener("click", dateRangehandleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (brand_id && platform_id) {
      getBrandDetails();
      fetchColumnData("METRICE");
    }
  }, [brand_id, platform_id]);

  useEffect(() => {
    if(transposeFormat === "VERTICAL"){
      if (fetchData.length > 0 && matricesData.length > 0) {
        setLoading(true);
        // Step 1: Filter matricesData for items where toggle is true and extract their ids
        const toggledIds = matricesData
          .filter((matrice) => matrice.toggle) // Keep only toggled items
          .map((matrice) => matrice.id); // Extract their ids
        // Step 2: Filter fetchData to keep only items whose ids are in the toggledIds array
        const filteredData = fetchData.filter((item) => toggledIds.includes(item.id));
    
        // Step 3: Sort filtered fetchData based on the order of toggledIds
        const sortedAndFilteredData = filteredData.sort(
          (a, b) => toggledIds.indexOf(a.id) - toggledIds.indexOf(b.id)
        );
    
        // Step 4: Update state with sorted and filtered data
        setfilterData(sortedAndFilteredData);
        setLoading(false);
      }
    } else {
      if (fetchData.length > 0 && matricesData.length > 0) {
        const filteredMatrices = matricesData?.filter(m => m.toggle); 
        const filteredColDefs = filteredMatrices?.map(item => ({
          field: item?.backend_matrice_name === "cost" ? "spend" : item?.backend_matrice_name,
          headerName: item?.matrice_name,
          sortable: false,
          cellRenderer: HorizontalCellRenderer,
          headerComponent: MatriceNameHeaderHorCmp,
          width: 150
        }));
        let new_columns_defs:any[] = [{
          field: "range_frontend_name",
          headerName: "Period",
          sortable: false,
          pinned: 'left',
          cellRenderer: MatricesNameHorRenderer,
          headerComponent: PeriodcolHeaderHorCmp,
          width: 170,
        }, ...filteredColDefs];
        setHorizontalcolData(new_columns_defs);
      }
    }
  }, [fetchData, matricesData]);
  
  const columnsApply = (ag_sectionType : string) => {
    if(ag_sectionType === "FIRST" && matricesDataDrawer?.length > 0){
      setMatricesData([...matricesDataDrawer]);
      updateColumns("METRICE", matricesDataDrawer);

      let positionchangedfilter =  matricesDataDrawer?.filter((item: Matrice, index: number) => item.id !== (index + 1));
      if(positionchangedfilter?.length > 0){
        setResetToggle(true);
      } else {
        setResetToggle(false);
      }
      setRowsToggle(false);
    }
    
    if(ag_sectionType === "SECOND" && matricesDataDrawer2?.length > 0 && parametersDataDrawer2?.length > 0){
      setMetricsData2([...matricesDataDrawer2]);
      setParametersData2([...parametersDataDrawer2])
      // updateColumns("METRICE", matricesDataDrawer2);
      onChangeStageHandler(view, performer, product_detail, matricesDataDrawer2, parametersDataDrawer2);

      let positionchangedfilter =  matricesDataDrawer2?.filter((item: Matrice, index: number) => item.id !== (index + 1));
      if(positionchangedfilter?.length > 0){
        setResetToggle2(true);
      } else {
        setResetToggle2(false);
      }
      setMetricsToggle(false);

      saveLastStateInLocalStorage(view, performer, product_detail, matricesDataDrawer2, parametersDataDrawer2);
      setDrawerSubOption('METRICES');
    }
  }

  const onResetColumnsHandler = (section_type: string) => {
    if(section_type === 'FIRST'){
      setMatricesDataDrawer((prev) => {
        const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
        
        // Update the position field in numerical order
        const updatedMatrices = sortedMatrices.map((item, index) => ({
          ...item,
          position: index, // Assign position based on the index in the sorted array
        }));
        
        return updatedMatrices;
      }); 
    } else if(section_type === 'SECOND'){
      setMatricesDataDrawer2((prev) => {
        const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
        
        // Update the position field in numerical order
        const updatedMatrices = sortedMatrices.map((item, index) => ({
          ...item,
          position: index, // Assign position based on the index in the sorted array
        }));
        
        return updatedMatrices;
      }); 
      setParametersDataDrawer2((prev) => {
        const sortedMatrices = [...prev].sort((a, b) => a.id - b.id);
        
        // Update the position field in numerical order
        const updatedMatrices = sortedMatrices.map((item, index) => ({
          ...item,
          position: index, // Assign position based on the index in the sorted array
        }));
        
        return updatedMatrices;
      });
    }
    
  }
  const [exportToggle, setExportToggle] = useState<boolean>(false);
  const [exportSelectionToggle, setExportSelectionToggle] = useState<boolean>(false);
  const [customExportToggle, setCustomExportToggle] = useState<boolean>(false);
  const [exportLoading, setExportLoading] =  useState<boolean>(false);

  const exportHandler = async (ip_parameters: string[]) => {
    let filter = {
      current_data_range: {
        start_date: `${InputRange?.rangeOne?.startDate.getFullYear()}-${String(
          InputRange?.rangeOne?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          InputRange?.rangeOne?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${InputRange?.rangeOne?.endDate.getFullYear()}-${String(
          InputRange?.rangeOne?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          InputRange?.rangeOne?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
      previous_data_range: {
        start_date: `${InputRange?.rangeTwo?.startDate.getFullYear()}-${String(
          InputRange?.rangeTwo?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          InputRange?.rangeTwo?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${InputRange?.rangeTwo?.endDate.getFullYear()}-${String(
          InputRange?.rangeTwo?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          InputRange?.rangeTwo?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
    };
    const token = localStorage.getItem("token");
    try {
      setExportLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/getComparasionOfTwoRange?brand_id=${brand_id}`;
      const result = await axios.post(api, filter, { headers });
      const { range } = result?.data?.data;
      if (!range || range.length !== 2) {
        appError("Invalid range data:", range);
      }
      const currentPeriod = range?.find(
        (item: any) => item.range_name === "current"
      );
      const previousPeriod = range?.find(
        (item: any) => item.range_name === "previous"
      );

      if (!currentPeriod || !previousPeriod) {
        appError("Missing 'current' or 'previous' range data.");
        return; // Trow error
      }

      const metrics = [
        { id: 1, matrice_name: "Impressions", backend_matrice_name: "impressions" },
        { id: 2, matrice_name: "Clicks", backend_matrice_name: "clicks" },
        { id: 3, matrice_name: "Spend", backend_matrice_name: "spend" },
        { id: 4, matrice_name: "Ad Sales", backend_matrice_name: "sales" },
        { id: 5, matrice_name: "Ad Sales %", backend_matrice_name: "ad_sales_perc" },
        {
          id: 6,
          matrice_name: "Gross Sales (Seller)",
          backend_matrice_name: "gross_sales_seller",
        },
        {
          id: 7,
          matrice_name: "Gross Sales (Vendor)",
          backend_matrice_name: "gross_sales_vendor",
        },
        {
          id: 8,
          matrice_name: "Organic Sales",
          backend_matrice_name: "organic_sales",
        },
        {
          id: 9,
          matrice_name: "Organic Sales %",
          backend_matrice_name: "organic_sales_perc",
        },
        { id: 10, matrice_name: "Ad Orders", backend_matrice_name: "orders" },
        { id: 11, matrice_name: "Ad Units", backend_matrice_name: "units" },
        {
          id: 12,
          matrice_name: "Gross Units (Seller)",
          backend_matrice_name: "gross_units_seller",
        },
        {
          id: 13,
          matrice_name: "Gross Units (Vendor)",
          backend_matrice_name: "gross_units_vendor",
        },
        { id: 14, matrice_name: "Organic Units", backend_matrice_name: "organic_units" },
        { id: 15, matrice_name: "ACOS", backend_matrice_name: "acos" },
        { id: 16, matrice_name: "TACOS", backend_matrice_name: "tacos" },
        { id: 17, matrice_name: "ROAS", backend_matrice_name: "roas" },
        { id: 18, matrice_name: "TROAS", backend_matrice_name: "troas" },
        { id: 19, matrice_name: "CTR", backend_matrice_name: "ctr" },
        { id: 20, matrice_name: "CVR", backend_matrice_name: "cvr" },
        { id: 21, matrice_name: "CPC", backend_matrice_name: "cpc" },
        { id: 22, matrice_name: "AOV", backend_matrice_name: "aov" },
        { id: 23, matrice_name: "CAC", backend_matrice_name: "cac" },
        {
          id: 24,
          matrice_name: "Glance View",
          backend_matrice_name: "gross_glanceviews",
        },
      ];
      const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

      if(transposeFormat === "VERTICAL"){
        
        const formattedArrayForCsv = metrics?.map(({ matrice_name, backend_matrice_name }) => {
          const getValue = (
            period: Record<string, number | string | null | undefined>,
            key: string
          ): string => {
            const value = period[key] ?? 0;
            return decimaldigitsMetrics.includes(backend_matrice_name)
              ? Number(value).toFixed(2)
              : Number(value).toFixed(0);
          };

          const result: Record<string, string> = { matrice_name };
        
          ip_parameters.forEach(param => {
            const key = `${backend_matrice_name}_${param}`;
        
            if (param === 'difference') {
              const current = Number(currentPeriod[backend_matrice_name] ?? 0);
              const previous = Number(previousPeriod[backend_matrice_name] ?? 0);
              const diff = current - previous;
              result[param] = decimaldigitsMetrics.includes(backend_matrice_name)
                ? diff.toFixed(2)
                : diff.toFixed(0);
            } else if (param === 'difference_percentage') {
              const current = Number(currentPeriod[backend_matrice_name] ?? 0);
              const previous = Number(previousPeriod[backend_matrice_name] ?? 0);
              const percentage = previous ? ((current - previous) / previous) * 100 : 0;
              result[param] = decimaldigitsMetrics.includes(backend_matrice_name)
                ? `${percentage.toFixed(2)}%`
                : `${percentage.toFixed(0)}%`;
            } else {
              const period = param === 'current_period' ? currentPeriod : previousPeriod;
              result[param] = getValue(period, backend_matrice_name);
            }
          });
        
          return result;
        });        
        
        downloadCSV(formattedArrayForCsv, "OverviewComparisonData.csv");
      } else {
        const formattedArrayForCsvHor: any[] = metrics.map(
          ({ id, matrice_name, backend_matrice_name }) => {
            const base = Number(currentPeriod[backend_matrice_name] ?? 0);
            const comp = Number(previousPeriod[backend_matrice_name] ?? 0);
            const diff = base - comp;
            const isDecimal = decimaldigitsMetrics.includes(backend_matrice_name);
        
            return {
              id,
              matrice_name,
              backend_matrice_name,
              current_period: isDecimal ? base.toFixed(2) : base.toFixed(0),
              comparison_period: isDecimal ? comp.toFixed(2) : comp.toFixed(0),
              difference: isDecimal ? diff.toFixed(2) : diff.toFixed(0),
              difference_percentage: comp
                ? `${(isDecimal ? ((diff / comp) * 100).toFixed(2) : ((diff / comp) * 100).toFixed(0))}%`
                : "0%",
            };
          }
        );
        
        // // Transpose logic
        const transposed = [
          ...ip_parameters?.map((key: string) => ({
            Period: key,
            ...Object.fromEntries(formattedArrayForCsvHor.map(m => [m.matrice_name, m[key]]))
          }))
        ];
        downloadCSV(transposed, "OverviewComparisonData.csv");
      }
      setExportSelectionToggle(false);

    } catch (error) {
      appError(error);
    } finally {
      setExportLoading(false);
    }
  }

  const exportCustomHandler = async (ip_Range: Range, ip_transposeFormat: string, ip_parameters: string[], ip_matrices: string[]) => {
    let filter = {
        current_data_range: {
          start_date: `${ip_Range?.rangeOne?.startDate.getFullYear()}-${String(
            ip_Range?.rangeOne?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeOne?.startDate.getDate()
          ).padStart(2, "0")}`,
          end_date: `${ip_Range?.rangeOne?.endDate.getFullYear()}-${String(
            ip_Range?.rangeOne?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeOne?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${ip_Range?.rangeTwo?.startDate.getFullYear()}-${String(
            ip_Range?.rangeTwo?.startDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeTwo?.startDate.getDate()
          ).padStart(2, "0")}`,
          end_date: `${ip_Range?.rangeTwo?.endDate.getFullYear()}-${String(
            ip_Range?.rangeTwo?.endDate.getMonth() + 1
          ).padStart(2, "0")}-${String(
            ip_Range?.rangeTwo?.endDate.getDate()
          ).padStart(2, "0")}`,
        },
      };
      const token = localStorage.getItem("token");
      try {
        setExportLoading(true);
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        let api = `${BASE_URL}dashboards/adsDashboard/getComparasionOfTwoRange?brand_id=${brand_id}`;
        const result = await axios.post(api, filter, { headers });
        const { range } = result?.data?.data;
        if (!range || range.length !== 2) {
          appError("Invalid range data:", range);
        }
        const currentPeriod = range?.find(
          (item: any) => item.range_name === "current"
        );
        const previousPeriod = range?.find(
          (item: any) => item.range_name === "previous"
        );
  
        if (!currentPeriod || !previousPeriod) {
          appError("Missing 'current' or 'previous' range data.");
          return; // Trow error
        }
  
        const metrics = [
          { id: 1, matrice_name: "Impressions", backend_matrice_name: "impressions" },
          { id: 2, matrice_name: "Clicks", backend_matrice_name: "clicks" },
          { id: 3, matrice_name: "Spend", backend_matrice_name: "cost" },
          { id: 4, matrice_name: "Ad Sales", backend_matrice_name: "sales" },
          { id: 5, matrice_name: "Ad Sales %", backend_matrice_name: "ad_sales_perc" },
          {
            id: 6,
            matrice_name: "Gross Sales (Seller)",
            backend_matrice_name: "gross_sales_seller",
          },
          {
            id: 7,
            matrice_name: "Gross Sales (Vendor)",
            backend_matrice_name: "gross_sales_vendor",
          },
          {
            id: 8,
            matrice_name: "Organic Sales",
            backend_matrice_name: "organic_sales",
          },
          {
            id: 9,
            matrice_name: "Organic Sales %",
            backend_matrice_name: "organic_sales_perc",
          },
          { id: 10, matrice_name: "Ad Orders", backend_matrice_name: "orders" },
          { id: 11, matrice_name: "Ad Units", backend_matrice_name: "units" },
          {
            id: 12,
            matrice_name: "Gross Units (Seller)",
            backend_matrice_name: "gross_units_seller",
          },
          {
            id: 13,
            matrice_name: "Gross Units (Vendor)",
            backend_matrice_name: "gross_units_vendor",
          },
          { id: 14, matrice_name: "Organic Units", backend_matrice_name: "organic_units" },
          { id: 15, matrice_name: "ACOS", backend_matrice_name: "acos" },
          { id: 16, matrice_name: "TACOS", backend_matrice_name: "tacos" },
          { id: 17, matrice_name: "ROAS", backend_matrice_name: "roas" },
          { id: 18, matrice_name: "TROAS", backend_matrice_name: "troas" },
          { id: 19, matrice_name: "CTR", backend_matrice_name: "ctr" },
          { id: 20, matrice_name: "CVR", backend_matrice_name: "cvr" },
          { id: 21, matrice_name: "CPC", backend_matrice_name: "cpc" },
          { id: 22, matrice_name: "AOV", backend_matrice_name: "aov" },
          { id: 23, matrice_name: "CAC", backend_matrice_name: "cac" },
          {
            id: 24,
            matrice_name: "Glance View",
            backend_matrice_name: "gross_glanceviews",
          },
        ];
        const sel_metrics = metrics?.filter(item => ip_matrices?.includes(item?.backend_matrice_name));
        const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];
  
        if(ip_transposeFormat === "VERTICAL"){
          
          const formattedArrayForCsv = sel_metrics?.map(({ matrice_name, backend_matrice_name }) => {
            const getValue = (
              period: Record<string, number | string | null | undefined>,
              key: string
            ): string => {
              const value = period[key] ?? 0;
              return decimaldigitsMetrics.includes(backend_matrice_name)
                ? Number(value).toFixed(2)
                : Number(value).toFixed(0);
            };
  
            const result: Record<string, string> = { matrice_name };
          
            ip_parameters.forEach(param => {
              const key = `${backend_matrice_name}_${param}`;
          
              if (param === 'difference') {
                const current = Number(currentPeriod[backend_matrice_name] ?? 0);
                const previous = Number(previousPeriod[backend_matrice_name] ?? 0);
                const diff = current - previous;
                result[param] = decimaldigitsMetrics.includes(backend_matrice_name)
                  ? diff.toFixed(2)
                  : diff.toFixed(0);
              } else if (param === 'difference_percentage') {
                const current = Number(currentPeriod[backend_matrice_name] ?? 0);
                const previous = Number(previousPeriod[backend_matrice_name] ?? 0);
                const percentage = previous ? ((current - previous) / previous) * 100 : 0;
                result[param] = decimaldigitsMetrics.includes(backend_matrice_name)
                  ? `${percentage.toFixed(2)}%`
                  : `${percentage.toFixed(0)}%`;
              } else {
                const period = param === 'current_period' ? currentPeriod : previousPeriod;
                result[param] = getValue(period, backend_matrice_name);
              }
            });
          
            return result;
          });        
          
          downloadCSV(formattedArrayForCsv, "OverviewComparisonData.csv");
        } else {
          const formattedArrayForCsvHor: any[] = sel_metrics?.map(
            ({ id, matrice_name, backend_matrice_name }) => {
              const base = Number(currentPeriod[backend_matrice_name] ?? 0);
              const comp = Number(previousPeriod[backend_matrice_name] ?? 0);
              const diff = base - comp;
              const isDecimal = decimaldigitsMetrics.includes(backend_matrice_name);
          
              return {
                id,
                matrice_name,
                backend_matrice_name,
                current_period: isDecimal ? base.toFixed(2) : base.toFixed(0),
                comparison_period: isDecimal ? comp.toFixed(2) : comp.toFixed(0),
                difference: isDecimal ? diff.toFixed(2) : diff.toFixed(0),
                difference_percentage: comp
                  ? `${(isDecimal ? ((diff / comp) * 100).toFixed(2) : ((diff / comp) * 100).toFixed(0))}%`
                  : "0%",
              };
            }
          );
          
          // // Transpose logic
          const transposed = [
            ...ip_parameters?.map((key: string) => ({
              Period: key,
              ...Object.fromEntries(formattedArrayForCsvHor.map(m => [m.matrice_name, m[key]]))
            }))
          ];
          downloadCSV(transposed, "OverviewComparisonData.csv");
        }
      } catch (error) {
        appError(error);
      } finally {
        setExportLoading(false);
        setCustomExportToggle(false);
      }
  }

  const parametersData: Parameter[] = [
    {
      id: 1,
      parameter_name: "Current Period",
      backend_parameter_name: "current_period",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      parameter_name: "Comparison Period",
      backend_parameter_name: "comparison_period",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      parameter_name: "Difference",
      backend_parameter_name: "difference",
      toggle: false,
      position: 2,
    },
    {
      id: 4,
      parameter_name: "Difference %",
      backend_parameter_name: "difference_percentage",
      toggle: false,
      position: 3,
    },
  ]

  // --------------------------------------------
  const stage_1 = [
    {frontend_name: 'PRODUCT VIEW', backend_name: 'product'},
    {frontend_name: 'AD TYPE VIEW', backend_name: 'ad_type'},
    {frontend_name: 'CAMPAIGN VIEW', backend_name: 'campaign'},
    {frontend_name: 'TARGETING VIEW', backend_name: 'targeting'},
    {frontend_name: 'BCG VIEW', backend_name: 'bcg'},
    {frontend_name: 'CST VIEW', backend_name: 'cst'},
    {frontend_name: 'PLACEMENT VIEW', backend_name: 'placement'}
  ];

  const stage_2 = [
    {frontend_name: 'TOP PERFORMER', backend_name: "TOP"},
    {frontend_name: 'BOTTOM PERFORMER', backend_name: "BOTTOM"},
  ];

  const product_view_stage_3 = ['CATEGORIES', 'SUBCATEGORIES', 'PRODUCT NAMES'];
  const [campaign_view_stage_3, setCampaign_view_stage_3] = useState<string[]>(['BY SALES', 'BY ACOS', 'BY ORDERS']);

  const [view, setView] = useState<string>('product');
  const [performer, setPerformer] = useState<string>("TOP");
  const [product_detail, setProduct_detail] = useState<string>('CATEGORIES');

  const [section2Toggle, setSection2Toggle] = useState<boolean>(false);
  const [metricsToggle, setMetricsToggle] = useState<boolean>(false);
  const [matricesDataDrawer2, setMatricesDataDrawer2] = useState<Matrice[]>([ 
    {
      id: 1,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
      toggle: false,
      position: 2,
    },
    {
      id: 4,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
      toggle: false,
      position: 3,
    },
    {
      id: 5,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
      toggle: false,
      position: 4,
    },
    {
      id: 6,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
      toggle: false,
      position: 5,
    },
    {
      id: 7,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
      toggle: false,
      position: 6,
    },
    {
      id: 8,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
      toggle: true,
      position: 7,
    },
    {
      id: 9,
      matrice_name: "Gross Units",
      backend_matrice_name: "gross_units",
      toggle: true,
      position: 8,
    },
    {
      id: 10,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
      toggle: false,
      position: 9,
    },
    {
      id: 11,
      matrice_name: "Ad Orders",
      backend_matrice_name: "orders",
      toggle: true,
      position: 10,
    },
    // {
    //   id: 12,
    //   matrice_name: "ROI",
    //   backend_matrice_name: "roi",
    //   toggle: false,
    //   position: 11,
    // },
    {
      id: 12,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
      toggle: true,
      position: 11,
    },
    {
      id: 13,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
      toggle: true,
      position: 12,
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
      toggle: false,
      position: 13,
    },
    // {
    //   id: 16,
    //   matrice_name: "TROI",
    //   backend_matrice_name: "troi",
    //   toggle: false,
    //   position: 15,
    // },
    {
      id: 15,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
      toggle: false,
      position: 14,
    },
  ]);
  const [metricsData2, setMetricsData2] = useState<Matrice[]>([ 
    {
      id: 1,
      matrice_name: "ACOS",
      backend_matrice_name: "acos",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      matrice_name: "AOV",
      backend_matrice_name: "aov",
      toggle: false,
      position: 1,
    },
    {
      id: 3,
      matrice_name: "CAC",
      backend_matrice_name: "cac",
      toggle: false,
      position: 2,
    },
    {
      id: 4,
      matrice_name: "Clicks",
      backend_matrice_name: "clicks",
      toggle: false,
      position: 3,
    },
    {
      id: 5,
      matrice_name: "CPC",
      backend_matrice_name: "cpc",
      toggle: false,
      position: 4,
    },
    {
      id: 6,
      matrice_name: "CTR",
      backend_matrice_name: "ctr",
      toggle: false,
      position: 5,
    },
    {
      id: 7,
      matrice_name: "CVR",
      backend_matrice_name: "cvr",
      toggle: false,
      position: 6,
    },
    {
      id: 8,
      matrice_name: "Gross Sales",
      backend_matrice_name: "gross_sales",
      toggle: true,
      position: 7,
    },
    {
      id: 9,
      matrice_name: "Gross Units",
      backend_matrice_name: "gross_units",
      toggle: true,
      position: 8,
    },
    {
      id: 10,
      matrice_name: "Impressions",
      backend_matrice_name: "impressions",
      toggle: false,
      position: 9,
    },
    {
      id: 11,
      matrice_name: "Ad Orders",
      backend_matrice_name: "orders",
      toggle: true,
      position: 10,
    },
    // {
    //   id: 12,
    //   matrice_name: "ROI",
    //   backend_matrice_name: "roi",
    //   toggle: false,
    //   position: 11,
    // },
    {
      id: 12,
      matrice_name: "Ad Sales",
      backend_matrice_name: "sales",
      toggle: true,
      position: 11,
    },
    {
      id: 13,
      matrice_name: "Spend",
      backend_matrice_name: "spend",
      toggle: true,
      position: 12,
    },
    {
      id: 14,
      matrice_name: "TACOS",
      backend_matrice_name: "tacos",
      toggle: false,
      position: 13,
    },
    // {
    //   id: 16,
    //   matrice_name: "TROI",
    //   backend_matrice_name: "troi",
    //   toggle: false,
    //   position: 15,
    // },
    {
      id: 15,
      matrice_name: "Ad Units",
      backend_matrice_name: "units",
      toggle: false,
      position: 14,
    },
  ]);
  const [parametersDataDrawer2, setParametersDataDrawer2] = useState<Parameter[]>([
    {
      id: 1,
      parameter_name: "Current Period",
      backend_parameter_name: "current",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      parameter_name: "Comparison Period",
      backend_parameter_name: "previous",
      toggle: true,
      position: 1,
    },
    {
      id: 3,
      parameter_name: "Difference",
      backend_parameter_name: "difference",
      toggle: true,
      position: 2,
    },
    {
      id: 4,
      parameter_name: "Difference %",
      backend_parameter_name: "difference_percentage",
      toggle: true,
      position: 3,
    },
  ]);
  const [parametersData2, setParametersData2] = useState<Parameter[]>([
    {
      id: 1,
      parameter_name: "Current Period",
      backend_parameter_name: "current",
      toggle: true,
      position: 0,
    },
    {
      id: 2,
      parameter_name: "Comparison Period",
      backend_parameter_name: "previous",
      toggle: true,
      position: 1,
    },
    {
      id: 3,
      parameter_name: "Difference",
      backend_parameter_name: "difference",
      toggle: true,
      position: 2,
    },
    {
      id: 4,
      parameter_name: "Difference %",
      backend_parameter_name: "difference_percentage",
      toggle: true,
      position: 3,
    },
  ]);
  const [drawerSubOption, setDrawerSubOption] = useState<string>("METRICES");
  const [resetToggle2, setResetToggle2] = useState<boolean>(false);
  const [section2ColDefs, setSection2ColDefs] = useState<ColDef<any>[]>([]);
  const [section2Data, setSection2Data] = useState<any[]>([]);
  const [draggedParameter, setDraggedParameter] = useState<Parameter | null>(
    null
  );
  const [agGridSection2Width, setAgGridSection2Width] = useState<number>(0);

  const parameterDragStarthandle = (item: Parameter) => {
    setDraggedParameter(item);
  };

  const parameterDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const parameterhandleDrop = (targetItem: Parameter, ag_parametersDataDrawer: Parameter[]) => {

    if (!draggedParameter || draggedParameter.id === targetItem.id) return;
  
    const draggedIndex = ag_parametersDataDrawer.findIndex(
      (item) => item?.id === draggedParameter.id
    );
    const targetIndex = ag_parametersDataDrawer.findIndex(
      (item) => item?.id === targetItem.id
    );
  
    if (draggedIndex === -1 || targetIndex === -1) return;
  
    // Clone the array to avoid mutating state directly
    const updatedMatricesData = [...ag_parametersDataDrawer];
  
    // Remove the dragged item
    const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
  
    // Insert it at the target index
    updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
  
    // Reassign position field based on new order
    const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
      ...item,
      position: index,
    }));

    return reorderedMatricesData;
  };

  // For Parameter
  const ParameterSwitchChangeHandler = (parameter_id: Number, ag_parametersDataDrawer: Parameter[]) => {
    const Exist = ag_parametersDataDrawer.find(
      (d: Parameter) => d?.id === parameter_id
    )?.toggle;
      // Count how many are ON
    const activeCount = ag_parametersDataDrawer.filter((item) => item.toggle).length;

    // If trying to turn off the last active one — prevent it
    if (Exist && activeCount === 1) {
      toast.error("Minimum 1 Parameter must remain active");
      return; // return undefined
    }

    // Proceed with toggle logic
    const newParameterArr = ag_parametersDataDrawer.map((d) =>
      d.id === parameter_id ? { ...d, toggle: !d.toggle } : d
    );

    return newParameterArr;
  };

  type MetricSplit = {
    base: string;
    suffix: 'current' | 'previous' | 'difference' | 'difference_percentage' | string;
  };
  
  const splitMetricKey = (metricKey: string): MetricSplit => {
    const suffixes = ['current', 'previous', 'difference', 'difference_percentage'];
  
    for (const suffix of suffixes) {
      if (metricKey.endsWith(`_${suffix}`)) {
        return {
          base: metricKey.slice(0, -1 * (`_${suffix}`.length)),
          suffix
        };
      }
    }
  
    // fallback if no known suffix is matched
    return { base: metricKey, suffix: '' };
  }
  
  const section2colors: Record<string, string> = {
    impressions: "#DA9191",
    clicks: "#8C9D6C",
    spend: "#8C9DB6",
    sales: "#9D88C8",
    organic_sales: "#C39155",
    gross_sales: "#599FC4",
    orders: "#D58A62",
    units: "#D5779A",
    organic_units: "#93a1D7",
    gross_units: "#998097",
    acos: "#AD8861",
    tacos: "#7EABAF",
    ctr: "#4F96D4",
    cvr: "#668F7D",
    cpc: "#A17398",
    aov: "#82909B",
    cac: "#BE7C89",
  }

  const Section2DiffRenderer = (params: any) => {
    const metric = splitMetricKey(params?.colDef?.field)?.base;
    const temp_arr = params?.context?.suffixArray?.map((item: any) => Number(item[params?.colDef?.field])); 
    const difference = Number(params?.data[`${metric}_current`]) - Number(params?.data[`${metric}_previous`]);
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];
    
    const absoluteDifference = decimaldigitsMetrics.includes(metric) ? (Number(difference?.toFixed(2))) : (difference);

    // Matrices where lower values are better
    const negativeGrowthMetrics = ["spend","acos","tacos", "cpc", "cac" ];

    const isPositiveTrend = negativeGrowthMetrics.includes(metric)
      ? Number(params?.data[`${metric}_previous`]) > Number(params?.data[`${metric}_current`]) // These should be lower
      : Number(params?.data[`${metric}_previous`]) < Number(params?.data[`${metric}_current`]); 

    const isDifferent = Number(params?.data[`${metric}_current`]) !== Number(params?.data[`${metric}_previous`]);

    return (
      <div
        className="w-[150px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: temp_arr?.length > 1 ? getRankedOpacityColor(Number(params?.value), temp_arr, section2colors[metric]) : section2colors[metric],
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {getFormattedValue(absoluteDifference)}
        </div>
        {isDifferent && (<div
          className="flex p-1 w-[22px] items-center gap-1 rounded-[4px]"
          style={{
            backgroundColor: isPositiveTrend ? "#DEF7E4" : "#FFECEB",
          }}
        >
          <img
            src={
              isPositiveTrend
                ? CurrentPeriodPositiveIcon
                : CurrentPeriodNegativeIcon
            }
            alt="Icon"
            style={{ cursor: "pointer" }}
          />
        </div>)}
      </div>
    );
  };

  const Section2DiffPercentRenderer = (params: any) => {
    const metric = splitMetricKey(params?.colDef?.field)?.base;
    const temp_arr = params?.context?.suffixArray?.map((item: any) => Number(item[params?.colDef?.field])); 
    // const difference = Number(params?.data[`${metric}_current`]) - Number(params?.data[`${metric}_previous`]);
    // const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    // Matrices where lower values are better
    const negativeGrowthMetrics = ["spend","acos","tacos", "cpc", "cac" ];

    const isPositiveTrend = negativeGrowthMetrics.includes(metric)
      ? Number(params?.data[`${metric}_previous`]) > Number(params?.data[`${metric}_current`]) // These should be lower
      : Number(params?.data[`${metric}_previous`]) < Number(params?.data[`${metric}_current`]); 

    const isDifferent = Number(params?.data[`${metric}_current`]) !== Number(params?.data[`${metric}_previous`]);

    return (
      <div
        className="w-[150px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: temp_arr?.length > 1 ? getRankedOpacityColor(Number(params?.value), temp_arr, section2colors[metric]) : section2colors[metric],
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {params?.value} %
        </div>
        {isDifferent && (<div
          className="flex p-1 w-[22px] items-center gap-1 rounded-[4px]"
          style={{
            backgroundColor: isPositiveTrend ? "#DEF7E4" : "#FFECEB",
          }}
        >
          <img
            src={
              isPositiveTrend
                ? CurrentPeriodPositiveIcon
                : CurrentPeriodNegativeIcon
            }
            alt="Icon"
            style={{ cursor: "pointer" }}
          />
        </div>)}
      </div>
    );
  };

  const getRankedOpacityColor  = (
    value: number,
    columnValues: number[],
    baseHexColor: string
  ): string => {
    // Step 1: Sort and remove duplicates (optional if needed)
    const sorted = [...columnValues]?.sort((a, b) => b - a); // Descending
  
    // Step 2: Find the rank index (0 = highest value)
    const rank = sorted.indexOf(value);
  
    // Step 3: Define number of steps
    const steps = columnValues?.length;
  
    // Step 4: Calculate opacity range (e.g., from 1 to 0.2)
    const maxOpacity = 1;
    const minOpacity = 0.2;
    const stepOpacity = (maxOpacity - minOpacity) / (steps - 1);
  
    const opacity = maxOpacity - rank * stepOpacity;
  
    // Step 5: Convert hex to rgba with opacity
    const rgba = hexToRgba(baseHexColor, opacity);
    return rgba;
  }
  
  const hexToRgba = (hex: string, opacity: number): string => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${opacity.toFixed(2)})`;
  }

  const Section2CurrRenderer = (params: any) => {
    const metric = splitMetricKey(params?.colDef?.field)?.base;
    const temp_arr = params?.context?.suffixArray?.map((item: any) => Number(item[params?.colDef?.field])); 
    return (
      <div
        className="w-[150px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: temp_arr?.length > 1 ? getRankedOpacityColor(Number(params?.value), temp_arr, section2colors[metric]) : section2colors[metric],
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {getFormattedValue(params?.value)}
        </div>
      </div>
    );
  };

  const Section2PrevRenderer = (params: any) => {
    const metric = splitMetricKey(params?.colDef?.field)?.base;
    const temp_arr = params?.context?.suffixArray?.map((item: any) => Number(item[params?.colDef?.field]));     return (
      <div
        className="w-[150px] flex px-6 py-2 items-center justify-end self-stretch gap-2"
        style={{
          backgroundColor: temp_arr?.length > 1 ? getRankedOpacityColor(Number(params?.value), temp_arr, section2colors[metric]) : section2colors[metric],
        }}
      >
        <div
          style={{
            color: "var(--Text-Primary-Black, #1C1C1E)",
            textAlign: "right",
            fontFamily: "Inter",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "16px",
          }}
        >
          {getFormattedValue(params?.value)}
        </div>
      </div>
    );
  };
  
  const section2Col1Renderer = (params: any) => {
    return (
      <div
      className="flex px-6 py-2 w-[150px] items-center justify-start gap-2"
      style={{
        // backgroundColor: "#F3F3F7",
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "start",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.value}
      </div>
    </div>
    )
  }

  const section2HeaderRenderer2 = (params: any) => {
    return (
      <div
      className="flex px-6 py-2 w-[150px] items-center justify-end self-stretch gap-2"
      style={{
        backgroundColor: "#F3F3F7",
        // backgroundColor: "skyblue"
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "end",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.displayName}
      </div>
    </div>
    )
  }

  const section2Col1Header = (params: any) => {
    return (
      <div
      className="flex px-2 py-2 w-[150px] items-center justify-start gap-2 h-[100%]"
      style={{
        // backgroundColor: "#F3F3F7",
      }}
    >
      <div
        style={{
          color: "var(--Text-Primary-Black, #1C1C1E)",
          textAlign: "start",
          fontFamily: "Inter",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "16px",
        }}
      >
        {params?.displayName}
      </div>
    </div>
    )
  }

  const fetchSection2Data = async (ag_view: string, ag_performer: string, ag_productDetail: string, UserInputRange: Range, ag_metrics: Matrice[], ag_parameters: Parameter[]) => {

    let selMetrics = ag_metrics
    .filter((m) => m?.toggle === true)
    .map((item) => item?.backend_matrice_name);
    let arr = ag_parameters
    .filter((m) => m?.toggle === true)
    .map((item) => item?.backend_parameter_name);

    let metricsColDef = ag_metrics?.filter((m) => m?.toggle === true)?.flatMap((metric) =>
      arr.map((suffix) => ({
        field: `${metric.backend_matrice_name}_${suffix}`,
        headerName: suffix === 'current' ? `${metric.matrice_name} Curr` : suffix === "difference" ? `${metric.matrice_name} Diff` : suffix === 'difference_percentage' ? `${metric.matrice_name} Diff %` : suffix === 'previous' ? `${metric.matrice_name} Comp` : `${metric.matrice_name} ${suffix.replace('_', ' ')}`,
        sortable: false,
        cellRenderer: suffix === "difference" ? Section2DiffRenderer : suffix === 'difference_percentage' ? Section2DiffPercentRenderer : suffix === 'current' ? Section2CurrRenderer : Section2PrevRenderer,
        headerComponent: section2HeaderRenderer2
      }))
    );

    let temp_ColDef: ColDef<any>[] = [];
    if(ag_view === 'product'){
      temp_ColDef = [{
        field: ag_productDetail === "CATEGORIES" ? "category" : ag_productDetail === "SUBCATEGORIES" ? "sub_category" : "product_name",
        headerName: ag_productDetail === "CATEGORIES" ? "Category" : ag_productDetail === "SUBCATEGORIES" ? "Sub Category" : "Product Name",
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'ad_type'){
      temp_ColDef = [{
        field: 'ad_type',
        headerName: 'Ad Type',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'campaign'){
      temp_ColDef = [{
        field: 'campaign_name',
        headerName: 'Campaign',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'targeting'){
      temp_ColDef = [{
        field: 'targeting',
        headerName: 'Targeting',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'bcg'){
      temp_ColDef = [{
        field: 'bcg_type',
        headerName: 'Keyword Type',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'cst'){
      temp_ColDef = [{
        field: 'searchterm',
        headerName: 'CST',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }
    else if(ag_view === 'placement'){
      temp_ColDef = [{
        field: 'placementclassification',
        headerName: 'Placement',
        pinned: 'left',
        headerComponent: section2Col1Header,
        cellRenderer: section2Col1Renderer
      }, ...metricsColDef];
    }

    const temp_filter = {
      current_data_range: {
        start_date: `${UserInputRange?.rangeOne?.startDate.getFullYear()}-${String(
          UserInputRange?.rangeOne?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeOne?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${UserInputRange?.rangeOne?.endDate.getFullYear()}-${String(
          UserInputRange?.rangeOne?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeOne?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
      previous_data_range: {
        start_date: `${UserInputRange?.rangeTwo?.startDate.getFullYear()}-${String(
          UserInputRange?.rangeTwo?.startDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeTwo?.startDate.getDate()
        ).padStart(2, "0")}`,
        end_date: `${UserInputRange?.rangeTwo?.endDate.getFullYear()}-${String(
          UserInputRange?.rangeTwo?.endDate.getMonth() + 1
        ).padStart(2, "0")}-${String(
          UserInputRange?.rangeTwo?.endDate.getDate()
        ).padStart(2, "0")}`,
      },
      product_detail_filter: {}
    }

    type ViewKey = "product" | "ad_type" | "campaign" | "targeting" | "bcg" | "cst" | "placement";
    const viewMap: Record<ViewKey, { backend_url: string; payload: any }> = {
      product: {
        backend_url: `sales/getComparasionOfTwoRange?brand_id=${brand_id}&page=${1}&limit=${ag_productDetail === "SUBCATEGORIES" || ag_productDetail === "CATEGORIES" ? 5 : 20}`,
        payload: {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: "gross_sales",
            sort_by: "difference",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: [ag_productDetail === "CATEGORIES" ? "category" : ag_productDetail === "SUBCATEGORIES" ? "sub_category" : "product_name"],
          metrics_column: selMetrics
        }
      }, 

      ad_type: {
        backend_url: `ads/getComparasionOfTwoRange?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: "spend",
            sort_by: "current",
            direction: "DESC"
          },
          product_detail_column: ['ad_type'],
          metrics_column: selMetrics
        }
      }, 

      campaign:  {
        backend_url: `ads/getComparasionOfTwoRange?brand_id=${brand_id}&page=${1}&limit=${20}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: temp_filter,
          conditions: [
            {metric: "orders", parameter: "current", operator: "=", initial_value: 0, dependent_value: 0},
            {metric: "orders", parameter: "previous", operator: ">", initial_value: 0, dependent_value: 0}
          ],
          sort: {
            metric: "orders",
            sort_by: "previous",
            direction: "ASC"
          },
          product_detail_column: ["campaign_name"],
          metrics_column: selMetrics
        } : {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            sort_by: "difference",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["campaign_name"],
          metrics_column: selMetrics
        }
      }, 

      targeting: {
        backend_url: `targeting/getComparasionOfTwoRange?brand_id=${brand_id}&page=${1}&limit=${50}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: temp_filter,
          conditions: [
            {metric: "orders", parameter: "current", operator: "=", initial_value: 0, dependent_value: 0},
            {metric: "orders", parameter: "previous", operator: ">", initial_value: 0, dependent_value: 0}
          ],
          sort: {
            metric: "orders",
            sort_by: "previous",
            direction: "ASC"
          },
          product_detail_column: ["targeting"],
          metrics_column: selMetrics
        } : {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            sort_by: "difference",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["targeting"],
          metrics_column: selMetrics
        }
      },

      bcg: {
        backend_url: `targeting/getComparasionOfTwoRange?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: "spend",
            sort_by: "current",
            direction: "DESC"
          },
          product_detail_column: ['bcg_type'],
          metrics_column: selMetrics
        }
      },

      cst: {
        backend_url: `searchterm/getComparasionOfTwoRange?brand_id=${brand_id}&page=${1}&limit=${50}`,
        payload: ag_productDetail === "BY ORDERS" ? {
          filter: temp_filter,
          conditions: [
            {metric: "orders", parameter: "current", operator: "=", initial_value: 0, dependent_value: 0},
            {metric: "orders", parameter: "previous", operator: ">", initial_value: 0, dependent_value: 0}
          ],
          sort: {
            metric: "orders",
            sort_by: "previous",
            direction: "ASC"
          },
          product_detail_column: ["searchterm"],
          metrics_column: selMetrics
        } : {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: ag_productDetail === "BY SALES" ? "sales" : ag_productDetail === "BY ACOS" ? "acos" : "orders",
            sort_by: "difference",
            direction: ag_performer === "TOP" ? "DESC" : "ASC"
          },
          product_detail_column: ["searchterm"],
          metrics_column: selMetrics
        }
      },

      placement: {
        backend_url: `placement/getPlacementComparasionOfTwoRange?brand_id=${brand_id}&page=${0}&limit=${0}`,
        payload: {
          filter: temp_filter,
          conditions: [],
          sort: {
            metric: "spend",
            sort_by: "current",
            direction: "DESC"
          },
          product_detail_column: ['placementclassification'],
          metrics_column: selMetrics
        }
      }
    }

    const token = localStorage.getItem("token");
    try {
      setSection2Toggle(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/${viewMap[ag_view as ViewKey]?.backend_url}`;
      let body = viewMap[ag_view as ViewKey]?.payload;
      const result = await axios.post(api, body, { headers });
      const {results} = result?.data?.data;
      if(results?.length > 0){
        let new_section2Data = results?.map((item: any) => {
          const newItem: any = {};
          for (const key in item) {
            if (key !== 'total_count') {
              if(body?.product_detail_column?.includes(key)){
                newItem[key] = item[key] != null ? item[key] : '';
              }
              else {
                newItem[key] = item[key] != null ? Number(item[key]) : getFormattedValue(0);
              }
            }          
          }
          return newItem;
        });
        setSection2Data(new_section2Data);
        setSection2ColDefs(temp_ColDef);
        setAgGridSection2Width(Number(selMetrics?.length * arr?.length));
      }
    } catch (error) {
      appError(error);
    } finally {
      setSection2Toggle(false);
    }
  }

  const onChangeStageHandler = async (ag_view: string, ag_performer: string, ag_productDetail: string, ag_matricsData: Matrice[], ag_parametersData: Parameter[]) => {
    fetchSection2Data(ag_view, ag_performer, ag_productDetail, InputRange, ag_matricsData, ag_parametersData);
  }

  const onChangeViewHandler = async (viewBackendName: string) => {

    let new_parameters_arr = [
      {
        id: 1,
        parameter_name: "Current Period",
        backend_parameter_name: "current",
        toggle: true,
        position: 0,
      },
      {
        id: 2,
        parameter_name: "Comparison Period",
        backend_parameter_name: "previous",
        toggle: true,
        position: 1,
      },
      {
        id: 3,
        parameter_name: "Difference",
        backend_parameter_name: "difference",
        toggle: true,
        position: 2,
      },
      {
        id: 4,
        parameter_name: "Difference %",
        backend_parameter_name: "difference_percentage",
        toggle: true,
        position: 3,
      },
    ];
    setParametersData2(new_parameters_arr);
    setParametersDataDrawer2(new_parameters_arr);
    let new_matrices_data: Matrice[] = [];
    if(viewBackendName === "cst"){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === 'campaign'){
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        // {
        //   id: 3,
        //   matrice_name: "CAC",
        //   backend_matrice_name: "cac",
        //   toggle: false,
        //   position: 2,
        // },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        // {
        //   id: 8,
        //   matrice_name: "Gross Sales",
        //   backend_matrice_name: "gross_sales",
        //   toggle: false,
        //   position: 7,
        // },
        // {
        //   id: 9,
        //   matrice_name: "Gross Units",
        //   backend_matrice_name: "gross_units",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        // {
        //   id: 15,
        //   matrice_name: "TACOS",
        //   backend_matrice_name: "tacos",
        //   toggle: false,
        //   position: 14,
        // },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === "product"){
      setProduct_detail('CATEGORIES');
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "CAC",
          backend_matrice_name: "cac",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Gross Sales",
          backend_matrice_name: "gross_sales",
          toggle: true,
          position: 7,
        },
        {
          id: 9,
          matrice_name: "Gross Units",
          backend_matrice_name: "gross_units",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 10,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 12,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 11,
        },
        {
          id: 13,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 12,
        },
        {
          id: 14,
          matrice_name: "TACOS",
          backend_matrice_name: "tacos",
          toggle: false,
          position: 13,
        },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 15,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 14,
        },
      ];
      onChangeStageHandler(viewBackendName, "TOP", "CATEGORIES", new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "CATEGORIES", new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === 'ad_type'){
      new_matrices_data = [ 
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        // {
        //   id: 3,
        //   matrice_name: "CAC",
        //   backend_matrice_name: "cac",
        //   toggle: false,
        //   position: 2,
        // },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        // {
        //   id: 8,
        //   matrice_name: "Gross Sales",
        //   backend_matrice_name: "gross_sales",
        //   toggle: false,
        //   position: 7,
        // },
        // {
        //   id: 9,
        //   matrice_name: "Gross Units",
        //   backend_matrice_name: "gross_units",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 12,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 11,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        // {
        //   id: 15,
        //   matrice_name: "TACOS",
        //   backend_matrice_name: "tacos",
        //   toggle: false,
        //   position: 14,
        // },
        // {
        //   id: 16,
        //   matrice_name: "TROI",
        //   backend_matrice_name: "troi",
        //   toggle: false,
        //   position: 15,
        // },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === 'bcg'){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === 'targeting'){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: true,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      setProduct_detail('BY SALES');
      setCampaign_view_stage_3(['BY SALES', 'BY ACOS', 'BY ORDERS']);
      onChangeStageHandler(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, "TOP", "BY SALES", new_matrices_data, new_parameters_arr);
    }

    if(viewBackendName === "placement"){
      new_matrices_data = [
        {
          id: 1,
          matrice_name: "ACOS",
          backend_matrice_name: "acos",
          toggle: true,
          position: 0,
        },
        {
          id: 2,
          matrice_name: "AOV",
          backend_matrice_name: "aov",
          toggle: false,
          position: 1,
        },
        {
          id: 3,
          matrice_name: "Clicks",
          backend_matrice_name: "clicks",
          toggle: false,
          position: 2,
        },
        {
          id: 4,
          matrice_name: "CPC",
          backend_matrice_name: "cpc",
          toggle: false,
          position: 3,
        },
        {
          id: 5,
          matrice_name: "CTR",
          backend_matrice_name: "ctr",
          toggle: false,
          position: 4,
        },
        {
          id: 6,
          matrice_name: "CVR",
          backend_matrice_name: "cvr",
          toggle: false,
          position: 5,
        },
        {
          id: 7,
          matrice_name: "Impressions",
          backend_matrice_name: "impressions",
          toggle: false,
          position: 6,
        },
        {
          id: 8,
          matrice_name: "Ad Orders",
          backend_matrice_name: "orders",
          toggle: false,
          position: 7,
        },
        // {
        //   id: 9,
        //   matrice_name: "ROI",
        //   backend_matrice_name: "roi",
        //   toggle: false,
        //   position: 8,
        // },
        {
          id: 9,
          matrice_name: "Ad Sales",
          backend_matrice_name: "sales",
          toggle: true,
          position: 8,
        },
        {
          id: 10,
          matrice_name: "Spend",
          backend_matrice_name: "spend",
          toggle: true,
          position: 9,
        },
        {
          id: 11,
          matrice_name: "Ad Units",
          backend_matrice_name: "units",
          toggle: false,
          position: 10,
        },
        // {
        //   id: 13,
        //   matrice_name: "Units_DRR",
        //   backend_matrice_name: "units_drr",
        //   toggle: false,
        //   position: 12,
        // },
      ];
      onChangeStageHandler(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
      saveLastStateInLocalStorage(viewBackendName, performer, product_detail, new_matrices_data, new_parameters_arr);
    }
    setMetricsData2(new_matrices_data);
    setMatricesDataDrawer2(new_matrices_data);
    setPerformer("TOP");
    setDrawerSubOption('METRICES');
    setView(viewBackendName);
    
  }

  const saveLastStateInLocalStorage = (ag_view: string, ag_performer: string, ag_productDetail: string, ag_metrics: Matrice[], ag_parameters: Parameter[]) => {
    const section2lastState = {ag_view, ag_performer, ag_productDetail, ag_metrics, ag_parameters};

    localStorage.setItem(
      'overview_comparison_section2TableData',
      JSON.stringify(section2lastState)
    );
  }

  return ( 
    <>
      <div className="flex flex-col" style={{
        maxHeight: "calc(100vh - 72px)",
        overflow: "hidden"
      }}>
        <div
          className="flex py-3 px-[20px] items-center justify-between gap-1 self-stretch"
          style={{
            borderBottom: "1px solid #EAEAED",
          }}
        >
          <div className="flex items-center gap-2">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Overview
            </div>
            <div
              className="flex h-[40px] px-[6px] py-1 items-start rounded-[4px]"
              style={{
                backgroundColor: "#F9F9FB",
              }}
            >
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/overview/comparison"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/overview/comparison/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/overview/comparison"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/overview/comparison"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  COMPARISON
                </div>
              </div>
              <div
                className="flex w-[100px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                  backgroundColor: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "#FFF"
                    : "#F9F9FB",
                  color: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "#1565C0"
                    : "#97979A",
                  boxShadow: location.pathname.includes(
                    "/Ads_dashboard/overview/summary"
                  )
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() =>
                  navigate(`/Ads_dashboard/overview/summary/${brand_id}`)
                }
              >
                <div
                  style={{
                    color: location.pathname.includes(
                      "/Ads_dashboard/overview/summary"
                    )
                      ? "var(--Text-Event-Blue, #1565C0)"
                      : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: location.pathname.includes(
                      "/Ads_dashboard/overview/summary"
                    )
                      ? 600
                      : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                  }}
                >
                  SUMMARY
                </div>
              </div>
            </div>
          </div>

          <div
            className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
            style={{
              border: "1px solid #EAEAED",
              position: "relative",
            }}
          >
            <div className="flex items-center gap-2">
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "14px",
                }}
              >
                {`${String(InputRange?.rangeOne?.startDate.getDate()).padStart(
                  2,
                  "0"
                )}/${String(
                  InputRange?.rangeOne?.startDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeOne?.startDate.getFullYear()} - ${String(
                  InputRange?.rangeOne?.endDate.getDate()
                ).padStart(2, "0")}/${String(
                  InputRange?.rangeOne?.endDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeOne?.endDate.getFullYear()} `}
              </div>
              <div
                style={{
                  color: "var(--Text-Primary-Grey, #97979A)",
                  fontFamily: "Inter",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "12px",
                }}
              >
                Vs
              </div>
              <div
                style={{
                  color: "var(--Text-Primary-Black, #1C1C1E)",
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "14px",
                }}
              >
                {`${String(InputRange?.rangeTwo?.startDate.getDate()).padStart(
                  2,
                  "0"
                )}/${String(
                  InputRange?.rangeTwo?.startDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeTwo?.startDate.getFullYear()} - ${String(
                  InputRange?.rangeTwo?.endDate.getDate()
                ).padStart(2, "0")}/${String(
                  InputRange?.rangeTwo?.endDate.getMonth() + 1
                ).padStart(
                  2,
                  "0"
                )}/${InputRange?.rangeTwo?.endDate.getFullYear()} `}
              </div>
            </div>
            <img
              src={CalenderIcon}
              alt="OverView Icon"
              style={{ cursor: "pointer" }}
              onClick={() => setDateToggle(true)}
              ref={dateRangeCmpButtonRef}
            />
            {dateToggle && (
              <div
                className="absolute "
                style={{ top: "37px", right: 0, zIndex: 100 }}
                ref={dateRangeCmpRef}
              >
                <CompareTwoDateRangeComponent
                  rangeOne={{
                    startDate: InputRange?.rangeOne?.startDate,
                    endDate: InputRange?.rangeOne?.endDate,
                  }}
                  rangeTwo={{
                    startDate: InputRange?.rangeTwo?.startDate,
                    endDate: InputRange?.rangeTwo?.endDate,
                  }}
                  apply={apply}
                  minDate={range?.min_date}
                  maxDate={range?.max_date}
                  setDateToggle={setDateToggle}
                />
              </div>
              // <DateRangeComponent range={} apply={apply} minDate={range?.min_date} maxDate={range?.min_date} />
            )}
          </div>
        </div>

        {/* Table Section */}
        <div className="px-[20px]" style={{
          overflow: "auto",
          // maxHeight: "calc(100vh - 72px - 105px)"
          maxHeight: "calc(100vh - 72px - 65px)"
        }}>
          <div
            className="flex w-full flex-col items-start rounded-[8px] mt-3 mb-[24px]"
            style={{
              backgroundColor: "#FFF",
              boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
            }}
          >
            <div className="flex px-4 py-2 justify-between items-end gap-4 self-stretch">
              <div className="flex flex-col justify-center items-start gap-1">
                <div
                  className="self-stretch"
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "26px",
                  }}
                >
                  Performance Overview
                </div>
                <div
                  className="self-stretch"
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  View and compare key metrics across different timeframes
                </div>
              </div>
              <div className="flex gap-2">
                <div className="flex w-[150px] gap-1">
                    <Select
                      className="w-full"
                      onChange={(e: any, value: any) => {
                        setTransposeFormat(value);
                        FetchComparisonDataHandler(InputRange, value);
                      }}
                      name="transpose"
                      value={transposeFormat}
                      indicator={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                            fill="#1C1C1C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      }
                      slotProps={{
                        listbox: {},
                      }}
                      sx={{
                        "--Input-focusedThickness": "0px",
                        height: "32px",
                        color: "#1C1C1E",
                        fontSize: 14,
                        fontWeight: 400,
                        lineHeight: "20px",
                        backgroundColor: WHITE.W_100,
                        boxShadow: "none",
                        border: `1px solid #EAEAED`,
                        [`& .${selectClasses.indicator}`]: {
                          transition: "0.2s",
                          [`&.${selectClasses.expanded}`]: {
                            transform: "rotate(-180deg)",
                          },
                        },
                        ":hover": {
                          backgroundColor: WHITE.W_100,
                        },
                      }}
                    >
                        <Option value={"VERTICAL"}>V-Comparison</Option>
                        <Option value={"HORIZONTAL"}>H-Comparison</Option>
                    </Select>
                </div>
                <Button
                  color="neutral"
                  sx={{
                    height: 32,
                    width: 80,
                    fontSize: 14,
                    fontWeight: 700,
                    backgroundColor: "#FFF",
                    lineHeight: "20px",
                    color: "#1C1C1E",
                    ":hover": {
                      backgroundColor: "#FFF",
                    },
                    paddingX: "6px",
                    paddingY: 0,
                    gap: "8px",
                    borderRadius: "6px",
                    border: `1px solid #EAEAED`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setRowsToggle(true);
                    // onClearFilterHandler();
                    //   setFilterToggle(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.42308 9.01434C4.00211 9.01434 3.64579 8.8685 3.35413 8.57684C3.06246 8.28517 2.91663 7.92885 2.91663 7.50788V4.42308C2.91663 4.00211 3.06246 3.64579 3.35413 3.35413C3.64579 3.06246 4.00211 2.91663 4.42308 2.91663H15.5768C15.9978 2.91663 16.3541 3.06246 16.6458 3.35413C16.9375 3.64579 17.0833 4.00211 17.0833 4.42308V7.50788C17.0833 7.92885 16.9375 8.28517 16.6458 8.57684C16.3541 8.8685 15.9978 9.01434 15.5768 9.01434H4.42308ZM4.42308 7.76434H15.5768C15.6517 7.76434 15.7132 7.74031 15.7612 7.69225C15.8093 7.6442 15.8333 7.58274 15.8333 7.50788V4.42308C15.8333 4.34822 15.8093 4.28677 15.7612 4.23871C15.7132 4.19065 15.6517 4.16663 15.5768 4.16663H4.42308C4.34822 4.16663 4.28677 4.19065 4.23871 4.23871C4.19065 4.28677 4.16663 4.34822 4.16663 4.42308V7.50788C4.16663 7.58274 4.19065 7.6442 4.23871 7.69225C4.28677 7.74031 4.34822 7.76434 4.42308 7.76434ZM4.42308 17.0833C4.00211 17.0833 3.64579 16.9375 3.35413 16.6458C3.06246 16.3541 2.91663 15.9978 2.91663 15.5768V12.5C2.91663 12.079 3.06246 11.7227 3.35413 11.431C3.64579 11.1393 4.00211 10.9935 4.42308 10.9935H15.5768C15.9978 10.9935 16.3541 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.5768C17.0833 15.9978 16.9375 16.3541 16.6458 16.6458C16.3541 16.9375 15.9978 17.0833 15.5768 17.0833H4.42308ZM4.42308 15.8333H15.5768C15.6517 15.8333 15.7132 15.8093 15.7612 15.7612C15.8093 15.7132 15.8333 15.6517 15.8333 15.5768V12.5C15.8333 12.4251 15.8093 12.3636 15.7612 12.3156C15.7132 12.2675 15.6517 12.2435 15.5768 12.2435H4.42308C4.34822 12.2435 4.28677 12.2675 4.23871 12.3156C4.19065 12.3636 4.16663 12.4251 4.16663 12.5V15.5768C4.16663 15.6517 4.19065 15.7132 4.23871 15.7612C4.28677 15.8093 4.34822 15.8333 4.42308 15.8333Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "700",
                      textAlign: "center",
                      lineHeight: "18px",
                      color: "#1C1C1E",
                    }}
                  >
                    Rows
                  </div>
                </Button>
                {/* <Button
                  sx={{
                    backgroundColor: "#FFF",
                    ":hover": {
                      backgroundColor: "#1565C0",
                    },
                    borderRadius: "6px",
                    paddingX: "6px",
                    paddingY: "0px",
                    border: `1px solid #EAEAED`,
                  }}
                >
                  <img
                    src={FullScreenIcon}
                    alt="FullScreen Icon"
                    style={{ cursor: "pointer" }}
                    // onClick={() => setDateToggle(true)}
                  />
                </Button> */}
                {/* <Button
                  sx={{
                    backgroundColor: "#FFF",
                    ":hover": {
                      backgroundColor: "#FFF",
                    },
                    borderRadius: "6px",
                    paddingX: "6px",
                    paddingY: "0px",
                    border: `1px solid #EAEAED`,
                  }}
                  onClick={() =>{
                    // if(rawData?.length > 0){
                    //   downloadCSV(rawData, "OverviewComparisonData.csv");
                    // }
                  }}
                >
                  <img
                    src={ExportIcon}
                    alt="FullScreen Icon"
                    style={{ cursor: "pointer" }}
                  />
                </Button> */}

                  <div className=""
                    style={{
                      position: 'relative'
                    }}>
                      <Button
                        sx={{
                          backgroundColor: "#FFF",
                          ":hover": {
                            backgroundColor: "#FFF",
                          },
                          borderRadius: "6px",
                          paddingX: "6px",
                          paddingY: "0px",
                          border: `1px solid #EAEAED`,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        ref={exportButtonRef}
                        onClick={() => setExportToggle(prev => !prev)}
                      >
                        <img
                          src={ExportIcon}
                          alt="Export Icon"
                          style={{ cursor: "pointer" }}
                        />
                      </Button>
                      {exportToggle && (
                        <div className="" style={{
                          position: "absolute",
                          top: 42, 
                          right: 0,
                          height: 100,
                          width: 150,
                          backgroundColor: "#FFF",
                          boxShadow: "0px 4px 16px 16px rgba(130,130,130, 0.05)",
                          borderRadius: "8px",
                          display: 'flex',
                          flexDirection: 'column',
                          zIndex: 50
                        }}
                        ref={exportRef}
                        >
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            setExportToggle(false);
                            setExportSelectionToggle(true);
                          }}>
                            Export Selection
                          </div>
                          <div className="p-4"
                          style={{
                            color: "#1C1C1E",
                            textAlign: "start",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "18px",
                            fontFamily: "Inter",
                            cursor: 'pointer'
                          }} onClick={() => {
                            setExportToggle(false);
                            setCustomExportToggle(true);
                          }}>
                            Custom Export
                          </div>
                        </div>
                      )}
                    </div>
              </div>
            </div>

            {/* Table */}
            {loading ? (
              <div
                className="flex justify-center items-center"
                style={{
                  height: "calc(100vh - 226px)",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <div style={{
                height: "calc(100vh - 226px)",
                width: "100%"
              }}>
                {datafetchingState === "SUCCESS" && filterdata?.length > 0 && (
                  <div
                    className={"ag-theme-quartz"}
                    style={{
                      maxWidth: "calc(100vw - 72px - 40px)",
                      width: agGridTableWidth,
                      height:  "100%"  ,
                      overflowY: "hidden",
                      borderRadius: "0px",
                    }}
                  >
                    <AgGridReact
                      rowData={filterdata}
                      columnDefs={transposeFormat === "VERTICAL" ? verticalcolDefs : horizontalcolData}
                      // defaultColDef={defaultColDef}
                      rowHeight={32}
                      headerHeight={36}
                    />
                  </div>
                )}
                {datafetchingState === "EMPTY" && (
                  <div
                    className="flex flex-col gap-10 justify-center items-center"
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="192"
                      height="162"
                      viewBox="0 0 192 162"
                      fill="none"
                    >
                      <g opacity="0.48">
                        <g filter="url(#filter0_di_1399_54050)">
                          <path
                            d="M7.99902 46.0938H167.999V118.475C167.999 128.994 159.471 137.522 148.951 137.522H27.0466C16.5269 137.522 7.99902 128.994 7.99902 118.475V46.0938Z"
                            fill="#DFE3E8"
                          />
                        </g>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M32.7602 21.332C29.5598 21.332 27.0459 23.8459 27.0459 27.0463C27.0459 30.2459 29.5598 32.7606 32.7602 32.7606C35.9605 32.7606 38.4744 30.2459 38.4744 27.0463C38.4744 23.8459 35.9605 21.332 32.7602 21.332Z"
                          fill="#C4CDD5"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M50.8554 21.332C47.655 21.332 45.1411 23.8459 45.1411 27.0463C45.1411 30.2459 47.655 32.7606 50.8554 32.7606C54.0557 32.7606 56.5696 30.2459 56.5696 27.0463C56.5696 23.8459 54.0557 21.332 50.8554 21.332Z"
                          fill="#C4CDD5"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M68.9505 21.332C65.7502 21.332 63.2363 23.8459 63.2363 27.0463C63.2363 30.2459 65.7502 32.7606 68.9505 32.7606C72.1509 32.7606 74.6648 30.2459 74.6648 27.0463C74.6648 23.8459 72.1509 21.332 68.9505 21.332Z"
                          fill="#C4CDD5"
                        />
                        <g filter="url(#filter1_di_1399_54050)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M167.999 23.2384V46.0951H7.99902L7.99902 23.2398C7.99902 14.8234 14.8219 8 23.2383 8H152.761C161.176 8 167.999 14.8227 167.999 23.2384ZM32.7609 21.3333C29.5605 21.3333 27.0466 23.8472 27.0466 27.0476C27.0466 30.2472 29.5605 32.7618 32.7609 32.7618C35.9612 32.7618 38.4751 30.2472 38.4751 27.0476C38.4751 23.8472 35.9612 21.3333 32.7609 21.3333ZM50.8561 21.3333C47.6557 21.3333 45.1418 23.8472 45.1418 27.0476C45.1418 30.2472 47.6557 32.7618 50.8561 32.7618C54.0564 32.7618 56.5703 30.2472 56.5703 27.0476C56.5703 23.8472 54.0564 21.3333 50.8561 21.3333ZM63.237 27.0476C63.237 23.8472 65.7509 21.3333 68.9512 21.3333C72.1516 21.3333 74.6655 23.8472 74.6655 27.0476C74.6655 30.2472 72.1516 32.7618 68.9512 32.7618C65.7509 32.7618 63.237 30.2472 63.237 27.0476Z"
                            fill="#919EAB"
                          />
                        </g>
                        <path
                          opacity="0.48"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M143.813 58.1484H97.3015C94.7307 58.1484 92.6504 60.2253 92.6504 62.7919V118.514C92.6504 121.081 94.7307 123.157 97.3015 123.157H143.813C146.384 123.157 148.464 121.081 148.464 118.514V62.7919C148.464 60.2253 146.384 58.1484 143.813 58.1484Z"
                          fill="#637381"
                        />
                        <path
                          opacity="0.24"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M32.1853 67.4355H50.7899C53.3608 67.4355 55.4411 65.3586 55.4411 62.7919C55.4411 60.2253 53.3608 58.1484 50.7899 58.1484H32.1853C29.6145 58.1484 27.5342 60.2253 27.5342 62.7919C27.5342 65.3586 29.6145 67.4355 32.1853 67.4355ZM27.5342 81.366C27.5342 78.7993 29.6145 76.7225 32.1853 76.7225H78.6968C81.2677 76.7225 83.348 78.7993 83.348 81.366C83.348 83.9326 81.2677 86.0095 78.6968 86.0095H32.1853C29.6145 86.0095 27.5342 83.9326 27.5342 81.366ZM32.1853 95.2965C29.6145 95.2965 27.5342 97.3734 27.5342 99.94C27.5342 102.507 29.6145 104.583 32.1853 104.583H78.6968C81.2677 104.583 83.348 102.507 83.348 99.94C83.348 97.3734 81.2677 95.2965 78.6968 95.2965H32.1853ZM27.5342 118.514C27.5342 115.947 29.6145 113.87 32.1853 113.87H78.6968C81.2677 113.87 83.348 115.947 83.348 118.514C83.348 121.081 81.2677 123.157 78.6968 123.157H32.1853C29.6145 123.157 27.5342 121.081 27.5342 118.514Z"
                          fill="#637381"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_di_1399_54050"
                          x="-0.000976562"
                          y="38.0938"
                          width="192"
                          height="123.429"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="8" dy="8" />
                          <feGaussianBlur stdDeviation="8" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1399_54050"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1399_54050"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="-2" dy="-2" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect2_innerShadow_1399_54050"
                          />
                        </filter>
                        <filter
                          id="filter1_di_1399_54050"
                          x="-0.000976562"
                          y="0"
                          width="192"
                          height="70.0947"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="8" dy="8" />
                          <feGaussianBlur stdDeviation="8" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1399_54050"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1399_54050"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="-2" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.270588 0 0 0 0 0.309804 0 0 0 0 0.356863 0 0 0 0.48 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect2_innerShadow_1399_54050"
                          />
                        </filter>
                      </defs>
                    </svg>
                    <div
                      style={{
                        color: "var(--Text-Primary-Grey, #97979A)",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "18px",
                      }}
                    >
                      No Result Found. Please Choose Another Filter.
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="flex w-full h-fit flex-col items-start rounded-[8px] my-3"
            style={{
              // boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
              // height: "fit-content"
            }}>
              <div
                className="w-full h-[45px] flex items-center justify-start self-stretch mb-[24px]"
                style={{
                  borderBottom: "1px solid #EAEAED",
                }}
              >
                {stage_1?.map((p) => (
                    <div className="flex-1"
                      style={{
                        display: "flex",
                        padding: "0px 16px",
                        justifyContent: "center",
                        alignItems: "center",
                        alignSelf: "stretch",
                        cursor: "pointer",
                        borderBottom:
                          view === p?.backend_name
                            ? "1px solid #1565C0"
                            : "0px",
                      }}
                      key={p?.backend_name}
                      onClick={() => onChangeViewHandler(p?.backend_name)}
                    >
                      <div
                        style={{
                          color:
                            view === p?.backend_name
                              ? "#1565C0"
                              : "var(--Text-Primary-Grey, #97979A)",
                          textAlign: "center",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontStyle: "normal",
                          fontWeight: view === p?.backend_name ? 600 : 500,
                          lineHeight: "10px",
                          letterSpacing: "1.6px",
                          textTransform: "uppercase",
                        }}
                      >
                        {`${p?.frontend_name}`}
                      </div>
                    </div>
                  ))}
              </div>

              {view === "product" ? (
                <View
                  view_type = {view}
                  viewHeaderName="Top and Bottom Performers by Gross Sales Difference"
                  subHeaderName={`${performer === "TOP" ? "Top" : "Bottom"} ${product_detail === "PRODUCT NAMES" ? "20" : "5"} ${product_detail} by ${performer === "TOP" ? "Highest" : "Lowest"} Gross Sales Difference`}
                  performerArr={stage_2}
                  stage_3={product_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  parameters={parametersData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
            ) : view === "ad_type" ? (
                <ViewComponent2 
                  headerName="Ad Type Performance Sorted by Spend from High to Low"
                  setMetricsToggle={setMetricsToggle}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  page_name={"comparison"}
                  />
            ) : view === "campaign" ? (
                <View
                  view_type = {view}
                  viewHeaderName="Top and Bottom 20 Campaigns by Sales, ACOS and Orders Difference"
                  subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 20 Campaigns by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 20 Campaigns by Highest ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 20 Campaigns with Current Ad Orders = 0 and Comparison AD Orders > 0, Sorted by Comparison Ad Orders" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 20 Campaigns by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 20 Campaigns by Lowest ACOS Difference" : ""}
                  performerArr={stage_2}
                  stage_3={campaign_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  parameters={parametersData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
            ): view === "targeting" ? (
                <View
                  view_type = {view}
                  viewHeaderName="Top and Bottom 50 Targeting Based on Sales, ACOS and Orders Difference"
                  subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 50 Targeting Entries by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 50 Targeting Entries by Highest ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 50 Targeting with Current Ad Orders = 0 and Comparison AD Orders > 0, Sorted by Comparison Ad Orders" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 50 Targeting Entries by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 50 Targeting Entries by Lowest ACOS Difference" : ""}
                  performerArr={stage_2}
                  stage_3={campaign_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  parameters={parametersData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
              ) : view === "bcg" ? (
                  <ViewComponent2 
                  headerName="BCG Analysis Sorted by Spend from High to Low"
                  setMetricsToggle={setMetricsToggle}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  page_name={"comparison"}
                  />
                ) : view === "cst" ? (
                  <View
                  view_type = {view}
                  viewHeaderName="Top and Bottom 50 CST Based on Sales, ACOS and Orders Difference"
                  subHeaderName={performer === "TOP" && product_detail === "BY SALES" ? "Top 50 CST by Highest Ad Sales Difference" :  performer === "TOP" && product_detail === "BY ACOS" ? "Top 50 CST by Highest Ad ACOS Difference" : performer === "TOP" && product_detail === "BY ORDERS" ? "Top 50 CST with Current Ad Orders = 0 and Comparison AD Orders > 0, Sorted by Comparison Ad Orders" : performer === "BOTTOM" && product_detail === "BY SALES" ? "Bottom 50 CST by Lowest Ad Sales Difference" :  performer === "BOTTOM" && product_detail === "BY ACOS" ? "Bottom 50 CST by Lowest ACOS Difference" : ""}
                  performerArr={stage_2}
                  stage_3={campaign_view_stage_3}
                  performer={performer}
                  product_detail={product_detail}
                  setProduct_detail={setProduct_detail}
                  setPerformer={setPerformer}
                  setMetricsToggle={setMetricsToggle}
                  onChangeStageHandler={onChangeStageHandler}
                  metrics={metricsData2}
                  parameters={parametersData2}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  saveLastState = {saveLastStateInLocalStorage}
                  />
              ) : view === "placement" && (
                  <ViewComponent2 
                  headerName="Placement Analysis Sorted by Spend from High to Low"
                  setMetricsToggle={setMetricsToggle}
                  section2ColDefs={section2ColDefs}
                  section2Data={section2Data}
                  loading={section2Toggle}
                  section2width={agGridSection2Width}
                  page_name={"comparison"}
                  />
              )}
          </div>
        </div>

      </div>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={rowsToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Rows
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() =>{
              setRowsToggle(false);
              setMatricesDataDrawer(matricesData); 
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex flex-col items-start self-stretch">
            {matricesDataDrawer.length > 0 &&
              matricesDataDrawer?.map((m: Matrice) => (
                <div
                  className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                  key={m?.matrice_name}
                  draggable
                  onDragStart={() => handleDragStart(m)}
                  onDragOver={handleDragOver}
                  onDrop={() => {
                    const updated = handleDrop(m, matricesDataDrawer);
                    if(updated){
                      setMatricesDataDrawer(updated);
                    }
                  }}
                >
                  <div className="flex items-center gap-1">
                    <img
                      src={DragAndDropIcon}
                      alt="Drag And Drop Icon"
                      style={{ cursor: "pointer" }}
                    />
                    <div
                      className=""
                      style={{
                        fontFamily: "Inter",
                        paddingLeft: "5px",
                        color: "#1C1C1E",
                        fontSize: "12px",
                        fontWeight: m?.toggle ? "600" : "400",
                        lineHeight: "18px",
                      }}
                    >
                      {m?.matrice_name}
                    </div>
                  </div>
                  <Switch
                    checked={m?.toggle}
                    onChange={() => {
                      const updated = handleSwitchChange(m?.id, matricesDataDrawer);
                      if (updated) {
                        setMatricesDataDrawer(updated);
                      }
                    }}
                  />
                </div>
              ))}
          </div>
        </DialogContent>
        <div
          className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
          style={{
            borderTop: "1px solid #EAEAED",
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            sx={{
              backgroundColor: "#FFF",
              ":hover": {
                backgroundColor: "#FFF",
              },
              borderRadius: "4px",
              paddingX: "6px",
              width: "50%",
              paddingY: "0px",
              border: `1px solid #EAEAED`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "inter",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              color: resetToggle ? "#1C1C1E" : "#B7B7B9",
              '&.Mui-disabled': {
                backgroundColor: 'white',  // Change this to the desired color
                color: "#B7B7B9"
              },
            }}
            onClick={() => onResetColumnsHandler('FIRST')}
            disabled={!resetToggle}
          >
            Reset Columns
          </Button>

          <Button
            onClick={() => columnsApply('FIRST')}
            sx={{
              height: "36px",
              width: "50%",
              backgroundColor: "#1565C0",
              color: "#FFF",
              borderRadius: "4px",
              padding: "0px 6px",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
            loading={loading}
          >
            Apply
          </Button>
        </div>
      </Drawer>

      <Drawer
        key={"right"}
        anchor={"right"}
        open={metricsToggle}
        size="md"
        slotProps={{
          backdrop: {
            sx: {
              backdropFilter: "none", // Disable the blur effect
            },
          },
        }}
      >
        <div
          className="flex p-4 items-center justify-between gap-10"
          style={{
            height: 52,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Columns
          </div>
          <div className="flex justify-between items-center gap-2">
            <div
              className="w-fit cursor-pointer"
              onClick={() =>{
                setDrawerSubOption('METRICES');
                setParametersDataDrawer2([...parametersData2]);
                setMatricesDataDrawer2([...metricsData2]);
                setMetricsToggle(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                  fill="#1C1C1C"
                />
              </svg>
            </div>
          </div>
        </div>
        <DialogContent sx={{ backgroundColor: WHITE.W_100 }}>
          <div className="flex h-full w-full p-4 flex-col items-start self-stretch">
            <div className="flex flex-col items-start gap-4 self-stretch">

              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "PARAMETERS"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "PARAMETERS") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("PARAMETERS");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Parameters
                    </div>
                    {drawerSubOption === "PARAMETERS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "PARAMETERS" && (
                  <div className="flex flex-col items-start self-stretch">
                    {parametersDataDrawer2?.map((p: Parameter) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={p?.parameter_name}
                          draggable
                          onDragStart={() => parameterDragStarthandle(p)}
                          onDragOver={parameterDragOverhandle}
                          onDrop={() => {
                            const updated = parameterhandleDrop(p, parametersDataDrawer2);
                            if(updated){
                              setParametersDataDrawer2(updated);
                            }
                          }}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: p?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {p?.parameter_name}
                            </div>
                          </div>
                          <Switch
                            checked={p?.toggle}
                            onChange={(event) => {
                              const updated = ParameterSwitchChangeHandler(p?.id, parametersDataDrawer2);
                              if(updated){
                                setParametersDataDrawer2(updated);
                              }
                            }}
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>

              <div
                className="flex flex-col items-start gap-4 self-stretch rounded-[4px] mb-4"
                style={{
                  border: "1px solid #EAEAED",
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom:
                      drawerSubOption === "METRICES"
                        ? "1px solid #EAEAED"
                        : "0px",
                  }}
                  onClick={() => {
                    if (drawerSubOption === "METRICES") {
                      setDrawerSubOption("");
                    } else {
                      setDrawerSubOption("METRICES");
                    }
                  }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                    {drawerSubOption === "METRICES" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {drawerSubOption === "METRICES" && (
                  <div className="flex flex-col items-start self-stretch">
                    {matricesDataDrawer2.length > 0 &&
                      matricesDataDrawer2?.map((m: Matrice) => (
                        <div
                          className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                          key={m?.matrice_name}
                          draggable
                          onDragStart={() => handleDragStart(m)}
                          onDragOver={handleDragOver}
                          onDrop={() =>{ 
                            const updated = handleDrop(m, matricesDataDrawer2);
                            if(updated){
                              setMatricesDataDrawer2(updated);
                            }
                          }}
                        >
                          <div className="flex items-center gap-1">
                            <img
                              src={DragAndDropIcon}
                              alt="Drag And Drop Icon"
                              style={{ cursor: "pointer" }}
                            />
                            <div
                              className=""
                              style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                              }}
                            >
                              {m?.matrice_name}
                            </div>
                          </div>
                          <Switch
                            checked={m?.toggle}
                            onChange={() => {
                              const updated = handleSwitchChange(m?.id, matricesDataDrawer2);
                              if (updated) {
                                setMatricesDataDrawer2(updated);
                              }
                            }}
                          />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <div
          className="h-[68px] w-full p-4 flex gap-6 justify-center items-center"
          style={{
            borderTop: "1px solid #EAEAED",
            backgroundColor: WHITE.W_100,
          }}
        >
          <Button
            sx={{
              backgroundColor: "#FFF",
              ":hover": {
                backgroundColor: "#FFF",
              },
              borderRadius: "4px",
              paddingX: "6px",
              width: "50%",
              paddingY: "0px",
              border: `1px solid #EAEAED`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "inter",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
              color: resetToggle2 ? "#1C1C1E" : "#B7B7B9",
              '&.Mui-disabled': {
                                backgroundColor: 'white',  // Change this to the desired color
                                color: "#B7B7B9"
                              },
            }}
            onClick={() => onResetColumnsHandler('SECOND')}
            disabled={!resetToggle2}
          >
            Reset Columns
          </Button>

          <Button
            onClick={() => columnsApply('SECOND') }
            sx={{
              height: "36px",
              width: "50%",
              backgroundColor: "#1565C0",
              color: "#FFF",
              borderRadius: "4px",
              padding: "0px 6px",
              fontSize: "12px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
            // loading={loading}
          >
            Apply
          </Button>
        </div>
      </Drawer> 

      {exportSelectionToggle && (
        <ComparisonExportSelectionModal
          setToggle={setExportSelectionToggle}
          parametersData={parametersData}
          exportfunc={exportHandler}
          loading={exportLoading}
        />
      )}

      {
        customExportToggle && (
          <OverviewComparisonCustomExportModal
            setToggle={setCustomExportToggle}
            ip_maxminRange={range}
            ip_Range={InputRange}
            parametersData={parametersData}
            matricesData={matricesData}
            exportfunc={exportCustomHandler}
            ip_transposeFormat={transposeFormat}
            loading={exportLoading}
            />
        )
      }
    </>
  );
};

export default OverviewComparisonPage;